import React, { useEffect, useMemo, useState, useRef } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  InputAdornment,
  Step,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  Paper,
  MenuItem,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  ThemeProvider,
  CardContent,
} from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { useNavigate, useParams,Link } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import {
  useDeleteCustomerProjectMutation,
  useDeleteCustomerTransactionMutation,
  useGetCustomerProjectQuery,
  useGetCompanyQuery,
  useGetCustomerTransactionQuery,
  useGetWorkOrderByCustomerProjectQuery,
  useRemovedCustomerProjectMMutation,
  useGetAllInvoiceQuery,
  useCreateEmailMutation, 
  useCreateTextMutation, 
  useCreateNoteMutation,
  useCreateNoteEmailMutation,
  useGetEmailTemplateQuery,
  useGetNoteTemplateQuery,
  useGetActivityHistoryQuery,
  useGetWorkOrderQuery,
  useGetAllWorkOrderHistoryCustomerQuery,
  useGetDriverQuery
} from "../../../Api/attoDeskApi";
import {
  ICustomer,
  ICustomerProject,
  ICustomerTransaction,
  IEmailTemplate,
  INoteTemplate,
  IInvoice,
  IQuoteWorkOrder,
  IActivityHistoryApiResponse,
  ICompanyDetails,
  IDriver
} from "../../../Api/Interface/api.interface";
// import NewCustomerTransactionPopUp from "./Components/NewCustomerTransactionPopUp";
import { useNotifier } from "../../../Core/Notifier";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import DeletePopupMutaion from "../../../Components/Delete/DeletePopupMutaion";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { CiSearch } from "react-icons/ci";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import NewPopUpCustomer from "../../Customer/Edit/index";
import NewCompanyOpeningHoursPopUp from "../../CompanyInfo/Components/NewCompanyOpeningHoursPopUp";
import NewCompanyOnlineOpeningHoursPopUp from "../../CompanyInfo/Components/NewCompanyOnlineOpeningHoursPopUp";
// import AddProject from "./Components/AddProject";
// import ViewInvoice from "./Components/ViewInvoice";
// import ViewWorkOrder from "./Components/ViewWorkOrder";
import dayjs,  { Dayjs } from "dayjs";
import ReceiptIcon from "@mui/icons-material/Receipt";
import RemoveCircleOutlineRoundedIcon from "@mui/icons-material/RemoveCircleOutlineRounded";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import AssignmentIcon from "@mui/icons-material/Assignment";
import InfoIcon from "@mui/icons-material/Info";
import CodeIcon from "@mui/icons-material/Code";
import HistoryIcon from "@mui/icons-material/History";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import NoteIcon from "@mui/icons-material/Note";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useFormik } from "formik";
import ChatIcon from "@mui/icons-material/Chat";
import DescriptionIcon from "@mui/icons-material/Description";
import {
  WorkOrderStatus,
} from "../../../Core/Enum/enum";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import axios from "axios";

import html2pdf from "html2pdf.js";
import moment from 'moment';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LanguageIcon from '@mui/icons-material/Language';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import { Visibility, VisibilityOff } from "@mui/icons-material";

const getStatusLabel = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "Paid";
    case WorkOrderStatus.Cancel:
      return "Canceled";
    case WorkOrderStatus.Pending:
      return "Pending";
      case WorkOrderStatus.Initiated:
        return "Initiated";
    default:
      return "Unknown Status";
  }
};

const getStatusColor = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "#4caf50";
    case WorkOrderStatus.Cancel:
      return "#f44336";
    case WorkOrderStatus.Pending:
      return "#ff9800";
   case WorkOrderStatus.Initiated:
  return "#2196f3"
    default:
      return "#9e9e9e";
  }
};
 

const Index = () => {
 
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 300);

  const [searchQueryProject, setSearchQueryProject] = useState("");
  const [currentSearchQueryProject, setCurrentSearchQueryProject] =
    useState("");
  const debouncedSearchQueryProject = useDebounce(searchQueryProject, 300);

  const [searchQueryInvoice, setSearchQueryInvoice] = useState("");
  const [searchQueryQuotes, setSearchQueryQuotes] = useState("");
  const [currentSearchQueryInvoice, setCurrentSearchQueryInvoice] =
    useState("");
  const debouncedSearchQueryInvoice = useDebounce(searchQueryInvoice, 300);
  const [currentSearchQueryQuote, setCurrentSearchQueryQuote] =
  useState("");
  const debouncedSearchQueryQuote = useDebounce(searchQueryQuotes, 300);
  const [searchQueryEmailTemplate, setSearchQueryEmailTemplate] = useState("");
  const [currentSearchQueryEmailTemplate, setCurrentSearchQueryEmailTemplate] =
    useState("");
  const debouncedSearchQueryEmailTemplate = useDebounce(searchQueryEmailTemplate, 300);
  const [searchQueryNoteTemplate, setSearchQueryNoteTemplate] = useState("");
  const [currentSearchQueryNoteTemplate, setCurrentSearchQueryNoteTemplate] =
    useState("");
  const debouncedSearchQueryNoteTemplate = useDebounce(searchQueryNoteTemplate, 300);
  const { id: customerId } = useParams<{ id: string }>();
  const [selectCustomer, setSelectCustomer] = useState<ICompanyDetails | null>(null);
    const [selectOnline, setSelectOnline] = useState<ICompanyDetails | null>(null);
  const [transactionData, setTransactionData] =
    useState<ICustomerTransaction>();

  const [deleteCategory] = useDeleteCustomerTransactionMutation();
  const [deleteProject] = useDeleteCustomerProjectMutation();

  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogOnline, setOpenDialogOnline] = useState(false);
  const [openAddTransaction, setOpenAddTransaction] = useState(false);
  const [openAddProject, setOpenAddProject] = useState(false);
  const [openViewInvoice, setOpenViewInvoice] = useState(false);
  const [openViewQuote, setOpenViewQuote] = useState(false);
  const [projectData, setProjecData] = useState<ICustomerProject>();

  const [openAddWorkOrder, setOpenAddWorkOrder] = useState(false);
  const [WorkOrderData, setWorkOrderData] = useState<IQuoteWorkOrder>();

  const { showErrorMessage, showMessage } = useNotifier();
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] =
    useState<ICustomerTransaction | null>(null);

  const [openDeleteProject, setOpenDeleteProject] = useState(false);
  const [projectToDelete, setProjectToDelete] =
    useState<ICustomerProject | null>(null);

  const [openDeleteProjectWrokOrder, setOpenDeleteProjectWrokOrder] =
    useState(false);
  const [projectWrokOrderToDelete, setProjectWrokOrderToDelete] =
    useState<IQuoteWorkOrder | null>(null);

  const [openProjectTable, setOpenProjectTable] = useState(false);
  const [projectId, setProjectId] = useState<number>(0);
  const [projectName, setProjectName] = useState<string>("");
  const [expandedSteps, setExpandedSteps] = useState<number[]>([]);

  const [newNote, { isLoading: isNoteSaving }] = useCreateNoteMutation();
  const [newNoteEmail, { isLoading: isNoteEmailSaving }] = useCreateNoteEmailMutation();
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {}, [customerId]);

  const [showProject, setShowProject] = useState(true);
  const [showInvoice, setShowInvoice] = useState(false);
  const [showQuotes, setShowQuotes] = useState(false);
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [showTextForm, setShowTextForm] = useState(false);
  const [showNoteForm, setShowNoteForm] = useState(false);
  const [showTime, setShowTime] = useState(false);
  const [showOnline, setShowOnline] = useState(false);
  const [newEmail, { isLoading: isEmailSending }] = useCreateEmailMutation();
  const [newText, { isLoading: isTextSending }] = useCreateTextMutation();
  const [isSendAsEmail, setIsSendAsEmail] = useState(false);
  const ReactQuillRef = useRef(null);
  const [invoiceId, setInvoiceId] = useState("");
  const [quoteId, setQuoteId] = useState("");
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [selectedRowsQuotes, setSelectedRowsQuotes] = useState<number[]>([]);
  const [showEmailDialog, setShowEmailDialog] = useState(false);
  const [invoiceEmailData, setInvoiceEmailData] = useState({ to: '', template:'', subject: '', message: '' , attachments: [] });
  const invoiceRef = useRef<HTMLDivElement | null>(null);
  const [generatedAttachments, setGeneratedAttachments] = useState<File[]>([]);
  const [loading, setLoading] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [emailLog, setEmailLog] = useState<EmailLogs[]>([]); 
  const [noteLog, setNoteLog] = useState<NoteLogs[]>([]); 
  const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);


  interface InvoiceEmailData {
    customer_id: number;
    to: string;
    template: string;
    subject: string;
    message: string;
    attachments: File[]; // Ensure attachments is an array of File objects
  }

  interface EmailLogs {
    id: number;
    created_at: string;
    subject: string;
   
  }

  
  

  interface NoteLogs {
    id: number;
    created_at: string;
    subject: string;
   
  }

  interface TransactionType {
    id: number;
    InvoiceNo: string;
   quoteWorkOrderCompanyId: number;
     quoteWorkOrderCustomerId: string;
     quoteWorkOrderNo: string;
     quoteWorkOrderIssueDate: string | null;
     quoteWorkOrderDueDate: string | null; 
     quoteWorkOrderAmount: number | null;
     quoteWorkOrderStatus: number;
    //  quoteWorkOrderSale: ProductSale[];
     quoteWorkOrderDiscount: string;
     quoteWorkOrderSubTotal: string;
     quoteWorkOrderSaleGrandTotal: string;
     quoteWorkOrderSaleDiscountDescription: string | null;
     customer: ICustomer;
     company: ICompanyDetails;
     created_at: string;
  }

  interface IProduct {
    productName: string;
    productDescription: string;
    productImg: String | null;
    numberOfPassengers: number | null;
    transferType: string;
    transferTypeFrom: string;
    transferTypeTo: string;
    transferTypeDescription: string;
    departureDateTime: Dayjs | null;
    returnDateTime: Dayjs | null;
    departureAddress: string;
    destinationAddress: string;
    multiDestination: string;
    quantity: number | null;
    price: number | null;
    tax: number | null;
    taxAmount: number | null;
    total: number;
    taxId: number | null;
    unitPriceWithDiscount: number | null;
    unitTotalWithDiscount: number;
    productType: string;
    productLongDescription: string;
    productShortDescription: string;
  }

  interface IDiscount {
    value: number | null;
    description: string;
  }

  const { data, isLoading, isError } = useGetDriverQuery({
    searchText: "",
    id: String(customerId),
  });


  const formatAddressReadOnly = (
    streetNumber: string,
    streetName: string,
    postalCode: string,
    city: string,
    province: string
  ) => {
    return `${streetNumber} ${streetName}, ${city}, ${province}, ${postalCode}`;
  };
  const initialCompanyAddress = formatAddressReadOnly(
    WorkOrderData?.company.companyStreetNumber || "",
    WorkOrderData?.company.companyStreetName || "",
    WorkOrderData?.company.companyPostalCode || "",
    WorkOrderData?.company.companyCity || "",
    WorkOrderData?.company.companyProvince || ""
  );
  
  const {
    data: customerTransactionData,
    isLoading: customerDataIsLoading,
    refetch,
  } = useGetCustomerTransactionQuery({
    searchText: currentSearchQuery,
    customerId: String(customerId),
    projectId: "",
  });

  const {
    data: activityHistoryData,
    isLoading: activityHistoryIsLoading,
    refetch: refetchActivityHistory,
  } = useGetActivityHistoryQuery({
    searchText: "",
    id: String(customerId),  
  });

  

  const {
    data: customerProjectData,
    isLoading: customerProjectDataIsLoading,
    refetch: cutomerProjectRefetch,
  } = useGetCustomerProjectQuery({
    searchText: currentSearchQueryProject,
    customerId: String(customerId),
    id: "",
  });

  const {
    data: workOrderProjectData,
    isLoading: workOrderProjectDataIsLoading,
    refetch: workOrderProjectRefetch,
  } = useGetWorkOrderByCustomerProjectQuery({
    searchText: "",
    quoteWorkOrderCustomerId: String(customerId),
    quoteWorkOrderCustomerProjectId: String(projectId),
  });

  const {
    data: invoiceData,
    isLoading: invoiceIsLoading,
    isError: invoiceError,
    refetch: invoiceRefetch,
  } = useGetAllInvoiceQuery({
    searchText: currentSearchQueryInvoice,
    id: "",
    quoteWorkOrderCustomerId: String(customerId),
    quoteWorkOrderCustomerProjectId: "",
  });

  const {
    data: quoteData,
    isLoading: quoteIsLoading,
    isError: quoteError,
    refetch: quoteRefetch,
  } = useGetWorkOrderQuery({
    searchText: currentSearchQueryQuote,
    id: "",
  });

  const {
    data: emailTemplateData,
    isLoading: emailTemplateIsLoading,
    isError: emailTemplateError,
    refetch: emailTemplateRefetch,
  } = useGetEmailTemplateQuery({
    searchText: currentSearchQueryEmailTemplate,
    // id: "",
  });

  const {
    data: noteTemplateData,
    isLoading: noteTemplateIsLoading,
    isError: noteTemplateError,
    refetch: noteTemplateRefetch,
  } = useGetNoteTemplateQuery({
    searchText: currentSearchQueryNoteTemplate,
    // id: "",
  });

  const {
    data: workOrderData,
    isLoading: workIsLoading,
    isError: workOrderError,
    refetch: workOrderRefetch,
  } = useGetWorkOrderQuery({
    searchText: "",
     id: "",
    // id: String(quoteId),
  });

const {
  data: workOrderHistoryData,
  isLoading: workOrderHistoryIsLoading,
  isError: workOrderHistoryError,
  refetch: workOrderHistoryRefetch,
} = useGetAllWorkOrderHistoryCustomerQuery({
  //id:"",
   id: String(customerId),
});

  const WorkOrderDataList = useMemo(() => {
    if (
      workOrderData &&
      Array.isArray(workOrderData.data) &&
      workOrderData.data.length > 0
    ) {
      return workOrderData.data[0] as IQuoteWorkOrder;
    }
    return null;
  }, [workOrderData]);

  

  const [newCustomer, { isLoading: rmoveIsLoading }] =
    useRemovedCustomerProjectMMutation();

  const customer = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as IDriver;
    }
    return null;
  }, [data]);


   const handlePasswordChange = (e: any) => setPassword(e.target.value);
  const handleConfirmChange = (e: any) => setConfirmPassword(e.target.value);

 const handleSubmit = async () => {
    if (!password || !confirmPassword) return showErrorMessage("Fill both fields");
    if (password !== confirmPassword) return showErrorMessage("Passwords do not match");

    setLoading(true);
    try {
       const headers = {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      };
      const response = await axios.post(`${API_URL}/driver/change-password`, {
        id: customerId,
        driverPassWord: password,
      }, { headers });

      if (response.data.status) {
        showMessage("Password updated successfully!");
        setPassword("");
        setConfirmPassword("");
      } else {
        showErrorMessage("Error: " + response.data.message);
      }
    } catch (error) {
      console.error(error);
      showErrorMessage("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  // const openingHours = Array.isArray(customer?.openingHours)
  // ? customer?.openingHours
  // : customer?.openingHours
  // ? JSON.parse(customer.openingHours)
  // : [
  //     { open: null, close: null },
  //     { open: null, close: null },
  //     { open: null, close: null },
  //     { open: null, close: null },
  //     { open: null, close: null },
  //     { open: null, close: null },
  //     { open: null, close: null },
  //   ];

  //    const onlineOpeningHours = Array.isArray(customer?.onlineOpeningHours)
  // ? customer?.onlineOpeningHours
  // : customer?.onlineOpeningHours
  // ? JSON.parse(customer.onlineOpeningHours)
  // : [
  //     { open: null, close: null },
  //     { open: null, close: null },
  //     { open: null, close: null },
  //     { open: null, close: null },
  //     { open: null, close: null },
  //     { open: null, close: null },
  //     { open: null, close: null },
  //   ];


  const activityHistory = useMemo(() => {
    if (data && data.data) {
      return data as IActivityHistoryApiResponse; // Cast the entire response to the expected type
    }
    return null;
  }, [data]);
  

  const transactions: ICustomerTransaction[] = useMemo(() => {
    if (
      customerTransactionData &&
      Array.isArray(customerTransactionData.data)
    ) {
      return customerTransactionData.data as ICustomerTransaction[];
    }
    return [];
  }, [customerTransactionData]);

  const project: ICustomerProject[] = useMemo(() => {
    if (customerProjectData && Array.isArray(customerProjectData.data)) {
      return customerProjectData.data as ICustomerProject[];
    }
    return [];
  }, [customerProjectData]);

  const workOrderProject: IQuoteWorkOrder[] = useMemo(() => {
    if (workOrderProjectData && Array.isArray(workOrderProjectData.data)) {
      return workOrderProjectData.data as IQuoteWorkOrder[];
    }
    return [];
  }, [workOrderProjectData]);

  const invoiceList: IInvoice[] = useMemo(() => {
    if (invoiceData && Array.isArray(invoiceData.data)) {
      return invoiceData.data as IInvoice[];
    }
    return [];
  }, [invoiceData]);

 

  const quoteList: IQuoteWorkOrder[] = useMemo(() => {
    if (quoteData && Array.isArray(quoteData.data)) {
      return quoteData.data as IQuoteWorkOrder[];
    }
    return [];
  }, [quoteData]);

  const emailTemplateList: IEmailTemplate[] = useMemo(() => {
    if (emailTemplateData && Array.isArray(emailTemplateData.data)) {
      return emailTemplateData.data as IEmailTemplate[];
    }
    return [];
  }, [emailTemplateData]);

  const noteTemplateList: INoteTemplate[] = useMemo(() => {
    if (noteTemplateData && Array.isArray(noteTemplateData.data)) {
      return noteTemplateData.data as INoteTemplate[];
    }
    return [];
  }, [noteTemplateData]);
  
  //  const handleSelectRow = (id: number) => {
  //   setSelectedRows((prevSelected) =>
  //     prevSelected.includes(id)
  //       ? prevSelected.filter((rowId) => rowId !== id)
  //       : [...prevSelected, id]
  //   );

  const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

    const handleSelectRow = async (id: number) => {
      // Update the selectedRows state by either adding or removing the row ID
      setSelectedRows((prevSelected) => {
        const updatedSelectedRows = prevSelected.includes(id)
          ? prevSelected.filter((rowId) => rowId !== id)
          : [...prevSelected, id];
    
        
        // if (!prevSelected.includes(id)) {
        //   handleGeneratePDF1(id); // Only generate PDF if the row is being selected
        // }
    
        return updatedSelectedRows;
      });
    };
    const handleSelectRowQuotes = async (id: number) => {
      // Update the selectedRows state by either adding or removing the row ID
      setSelectedRowsQuotes((prevSelected) => {
        const updatedSelectedRows = prevSelected.includes(id)
          ? prevSelected.filter((rowId) => rowId !== id)
          : [...prevSelected, id];
    
        
        // if (!prevSelected.includes(id)) {
        //   handleGeneratePDFQuote(id); // Only generate PDF if the row is being selected
        // }
    
        return updatedSelectedRows;
      });
    };

  const handleSelectAllRows = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
        setSelectedRows(invoiceList.map((transaction) => transaction.id));
    } else {
        setSelectedRows([]);
    }
};

const handleSelectAllRowsQuotes = (event: React.ChangeEvent<HTMLInputElement>) => {
  if (event.target.checked) {
      setSelectedRowsQuotes(quoteList.map((transaction) => transaction.id));
  } else {
      setSelectedRowsQuotes([]);
  }
};


const handleEmailDialogOpen = async () => {
 
  setPdfLoading(true);
  setInvoiceEmailData(prevState => ({
    to: prevState.to, // Keep the 'to' value unchanged
    template: '',
    subject: '',
    message: '',
    attachments: [],
  }));

  try {
    const pdfAttachments: (File | null | undefined)[] = [];

    for (const selectedRowId of selectedRows) {
      const transaction = invoiceList.find((inv) => inv.id === selectedRowId);
    
      if (!transaction) {
        console.warn(`Invoice not found for ID: ${selectedRowId}`);
        continue;
      }

      const pdfBlob = await handleGeneratePDF2(transaction.id);
   

      if (!pdfBlob) {
        console.warn(`Failed to generate PDF for Invoice ID: ${selectedRowId}`);
        continue;
      }

      // Ensure pdfBlob is not undefined and is a valid Blob
      if (pdfBlob instanceof Blob) {
        const file = new File([pdfBlob], `Invoice-${transaction.InvoiceNo}.pdf`, {
          type: "application/pdf",
        });
        pdfAttachments.push(file);
      } else {
        console.warn(`Invalid Blob generated for Invoice ID: ${selectedRowId}`);
      }
    }

    // Save generated attachments to state
    setGeneratedAttachments(
      pdfAttachments.filter((attachment): attachment is File => Boolean(attachment))
    );
    console.log("Generated Attachments:", pdfAttachments);
    // Open the email dialog
    setPdfLoading(false);
    setShowEmailDialog(true);

}catch (error) {
    console.error("Error opening email dialog:", error);
    setPdfLoading(false);
  }

};

const handleQuoteEmailDialogOpen = async () => {
 
  setPdfLoading(true);
  setInvoiceEmailData(prevState => ({
    to: prevState.to, // Keep the 'to' value unchanged
    template: '',
    subject: '',
    message: '',
    attachments: [],
  }));

  try {
    const pdfAttachments: (File | null | undefined)[] = [];

    for (const selectedRowId of selectedRowsQuotes) {
      const transaction = quoteList.find((inv) => inv.id === selectedRowId);
    
      if (!transaction) {
        console.warn(`Work order not found for ID: ${selectedRowId}`);
        continue;
      }
       setQuoteId(String(transaction.id))

       
      
      const pdfBlob = await handleGeneratePDFQuote(transaction.id);
   

      if (!pdfBlob) {
        console.warn(`Failed to generate PDF for Word order ID: ${selectedRowId}`);
        continue;
      }

      // Ensure pdfBlob is not undefined and is a valid Blob
      if (pdfBlob instanceof Blob) {
        const file = new File([pdfBlob], `WorkOrder-${transaction.quoteWorkOrderNo}.pdf`, {
          type: "application/pdf",
        });
        pdfAttachments.push(file);
      } else {
        console.warn(`Invalid Blob generated for Work order ID: ${selectedRowId}`);
      }
    }

    // Save generated attachments to state
    setGeneratedAttachments(
      pdfAttachments.filter((attachment): attachment is File => Boolean(attachment))
    );
    //console.log("Generated Attachments:", pdfAttachments);
    // Open the email dialog
    setPdfLoading(false);
    setShowEmailDialog(true);
}catch (error) {
    console.error("Error opening email dialog:", error);
    setPdfLoading(true);
  }
};


const handleGeneratePDF2 = async (invoiceId: any): Promise<Blob | null> => {
    try {
      const invoice = invoiceList.find((inv) => inv.id === invoiceId);
      if (!invoice) {
        throw new Error(`Invoice not found for ID: ${invoiceId}`);
      }

      const invoiceContent = document.getElementById("invoice-content");
      if(invoiceContent)
      {
        invoiceContent.style.display = 'block';
      }

      if (!invoiceContent) {
        console.error(`Invoice content not found for Invoice ID: ${invoiceId}`);
      }

      const options = {
         margin: 1,
        filename: `Invoice_${invoiceId}.pdf`,
        image: { type: 'jpeg', quality: 0.8 }, // You can experiment with different qualities (0.8 for reduced size)
        html2canvas: {
          scale: 2, // Reduce scale for a lower resolution to make the PDF smaller
          useCORS: true, // Ensure that cross-origin images are handled properly
        },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      };

  // Generate PDF Blob
  const pdfBlob = await html2pdf().from(invoiceContent).set(options).outputPdf('blob');
  // console.log('PDF Blob generated:', pdfBlob);

  // // Download the generated PDF
  // const pdfUrl = URL.createObjectURL(pdfBlob);

  
  // const link = document.createElement('a');
  // link.href = pdfUrl;
  // link.download = `Invoice_${invoiceId}.pdf`;
  // document.body.appendChild(link);

  // Trigger the download
  // link.click();

  // Clean up
  // document.body.removeChild(link);
  // URL.revokeObjectURL(pdfUrl);
  if(invoiceContent)
    {
  invoiceContent.style.display = 'none';
    }
  return pdfBlob;

      // const doc = new jsPDF({
      //   unit: 'mm',
      //   format: 'a4',
      //   orientation: 'portrait',
      //   compress: true, 
      // });
      // doc.html(invoiceContent, {
      //   callback: (doc) => {
      //     const pdfBlob = doc.output("blob");

      //     // Trigger the download of the PDF
      //     const url = URL.createObjectURL(pdfBlob);
      //     const link = document.createElement('a');
      //     link.href = url;
      //     link.download = `Invoice-${invoiceId}.pdf`;
      //     link.click();

      //     // Clean up the URL after download
      //     URL.revokeObjectURL(url);

      //     // Resolve the Promise with the pdfBlob
      //     resolve(pdfBlob);
      //   },
      //   x: 10,
      //   y: 10,
      //   width: 200, // Scale to fit the page width
      //   windowWidth: 800, 
      // });
    } catch (error) {
      console.error(`Failed to generate PDF for Invoice ID: ${invoiceId}`, error);
      return null;
//reject(error);
    }
  // });
};



const handleGeneratePDFQuote = async (quoteId: any): Promise<Blob | null> => {
  try {

    setQuoteId(quoteId);
    await new Promise((resolve) => setTimeout(resolve, 2000));

    const quote = quoteList.find((inv) => inv.id === quoteId);

   
    if (!quote) {
      throw new Error(`Work order not found for ID: ${quoteId}`);
    }

    const quoteContent = document.getElementById("quote-content");


    if(quoteContent)
    {
     
      quoteContent.style.display = 'block';
    }

    if (!quoteContent) {
      console.error(`Work order content not found for work order ID: ${quoteId}`);
    }

 
    const options = {
       margin: 1,
      filename: `WorkOrder_${quote.quoteWorkOrderNo}.pdf`,
      image: { type: 'jpeg', quality: 0.8 }, // You can experiment with different qualities (0.8 for reduced size)
      html2canvas: {
        scale: 2, // Reduce scale for a lower resolution to make the PDF smaller
        useCORS: true, // Ensure that cross-origin images are handled properly
        logging: true, // Optional: Log for debugging
      //  width: quoteContent && quoteContent.scrollWidth,
       // height: quoteContent && quoteContent.scrollHeight,
        //x: 0, // Optional: X position to start rendering
       // y: 0, // Optional: Y position to start rendering
      },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    };

    

// Generate PDF Blob
const pdfBlob = await html2pdf().from(quoteContent).set(options).outputPdf('blob');


  
          // const url = URL.createObjectURL(pdfBlob);
          // const link = document.createElement('a');
          // link.href = url;
          // link.download = `${quote.quoteWorkOrderNo}.pdf`;
          // link.click();
          // URL.revokeObjectURL(url);

if(quoteContent)
  {
    quoteContent.style.display = 'none';
  }
return pdfBlob;
  } catch (error) {
    console.error(`Failed to generate PDF for Work order ID: ${quoteId}`, error);
    return null;

  }

};


  const handleEmailDialogClose = () => setShowEmailDialog(false);

  const handleQuoteEmailDialogClose = () => setShowEmailDialog(false);

//   const handleSendEmail = async () => {
//     setLoading(true);

//     try {
//         if (!generatedAttachments.length) {
//             showErrorMessage("No PDFs generated to attach. Please try again.");
//             return;
//         }

//         const customerFirstName = customer?.customerFirstName || "Customer"; 
//         const updatedMessage = invoiceEmailData.message.replace(/\[customer_name\]/g, customerFirstName);

//         const emailData = {
//             customer_id: customerId ? parseInt(customerId, 10) : 0,
//             to: invoiceEmailData.to,
//             subject: invoiceEmailData.subject,
//             //message: invoiceEmailData.message,
//             message: convertPlainTextToHTML(updatedMessage),
//             attachments: generatedAttachments,
//         };

//         // Create FormData object
//         const formData = new FormData();
//         formData.append("customer_id", emailData.customer_id.toString());
//         formData.append("to", emailData.to);
//         formData.append("subject", emailData.subject);
//         formData.append("message", emailData.message);

//         emailData.attachments.forEach((file) => {
//             formData.append("attachments[]", file);
//         });

//         const headers = {
//             Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
//         };

//         const emailResponse = await axios.post(`${API_URL}/send-email`, formData, { headers });

//         if (emailResponse) {
//             setSelectedRows([]);
//             showMessage("Email sent successfully");
//             await refetchActivityHistory();
//             setInvoiceEmailData({ ...invoiceEmailData, subject: "", message: "" });
//         } else {
//             showErrorMessage("Failed to send email");
//         }
//     } catch (error) {
//         console.error("Error during email sending:", error);
//         showErrorMessage("Failed to send email");
//     } finally {
//         handleEmailDialogClose();
//         setLoading(false);
//     }
// };

  
  
  


  const stripHtmlTags = (html: string) => {
    return html.replace(/<\/?[^>]+(>|$)/g, "");
  };


  

      const emailFormik = useFormik({
        initialValues: {
          to: "",
          subject: "",
          message: "",
          template: "",
        },
        validate: (values) => {
          const errors: { [key: string]: string } = {};
          if (!values.to) {
            errors.to = "Email address is required";
          } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.to)) {
            errors.to = "Invalid email address";
          }
         
          return errors;
        },
        onSubmit: async (values, { setValues  }) => {
          try {
            // Prepare the data to send via the newEmail API
            const emailData = {
              customer_id: customerId,
              to: values.to,
              subject: values.subject,
              message: values.message,
            };
      
            // Call the newEmail mutation API and wait for the response
            const emailResponse = await newEmail(emailData).unwrap();
            if (!emailResponse) {
              showErrorMessage("Failed to send email");
             // showErrorMessage(emailResponse.message);
            } else {
              showMessage("Email Sent successfully");
              const refetchResult = await refetchActivityHistory();
              setValues({
                ...values, // Preserve the "to" field
                subject: "", // Reset subject
                message: "", // Reset message
                template: "", // Reset template
              });
            }

          } catch (error) {
            showErrorMessage("Failed to send email");
          }
        },
      });

     


      // const textFormik = useFormik({
      //   initialValues: {
      //     message: "",
      //   },
        
      //   onSubmit: async (values, { setValues  }) => {
      //     try {
      //       // Prepare the data to send via the newEmail API
      //       const textData = {
      //         customer_id: customerId,
      //         phone_no: customer?.companyMobileNumber || "",
      //         message: stripHtmlTags(values.message),
      //       };
      
      //       // Call the newEmail mutation API and wait for the response
      //       const textResponse = await newText(textData).unwrap();
      //       if (!textResponse) {
      //         showErrorMessage("Failed to send sms");
      //        // showErrorMessage(emailResponse.message);
      //       } else {
      //         showMessage("Sms Sent successfully");
      //         const refetchResult = await refetchActivityHistory();
      //         setValues({
      //           ...values, // Preserve the "to" field
      //           message: "", // Reset message
      //         });
      //       }

      //     } catch (error) {
      //       showErrorMessage("Failed to send email");
      //     }
      //   },
      // });

      // const textFormValid = useMemo(() => {
      //   return (
      //     stripHtmlTags(textFormik.values.message) !=="" &&
      //     stripHtmlTags(textFormik.values.message) !==undefined 
      //   );
      // }, [textFormik.values.message]);

      const emailFormValid = useMemo(() => {
        return (
          emailFormik.values.to !== "" &&
          emailFormik.values.to !== undefined &&
          emailFormik.values.subject !== "" &&
          emailFormik.values.subject !== undefined &&
          stripHtmlTags(emailFormik.values.message) !=="" &&
          stripHtmlTags(emailFormik.values.message) !==undefined 
        );
      }, [emailFormik.values.to, emailFormik.values.subject, emailFormik.values.message]);

      // const handleNoteEmailSubmit = async (values: any, resetForm: () => void) => {
      //   try {
        
      //     const noteEmailData = {
      //       customer_id: customerId,
      //       to: customer?.companyEmail || "", // Assuming customer is available
      //       note_subject: values.subject,
      //       note_message: values.message,
      //     };
      
      //     // Call the send email API
      //     const emailResponse = await newNoteEmail(noteEmailData).unwrap();
      //     showMessage("Email Sent successfully");
      //     const refetchResult = await refetchActivityHistory();
      //     resetForm();
      //     setIsSendAsEmail(false);
      //   } catch (error) {
      //     showErrorMessage("Failed to send email");
      //   }
      // };
      
      // Function to handle saving a note
      // const handleNoteSaveSubmit = async (values: any, resetForm: () => void) => {
      //   try {
          
      //     const noteData = {
      //       customer_id: customerId,
      //       note_subject: values.subject,
      //       note_message: stripHtmlTags(values.message),
      //     };
      
      //     // Call the save note API
      //     const noteResponse = await newNote(noteData).unwrap();
      //     showMessage("Note saved successfully");
      //     const refetchResult = await refetchActivityHistory();
      //     resetForm(); // Reset the form on success
      //   } catch (error) {
      //     showErrorMessage("Failed to save note");
      //   } 
      // };

      // const noteFormik = useFormik({
      //   initialValues: {
      //     subject: "",
      //     message: "",
      //   },
     
      //   onSubmit: async (values, { resetForm }) => {
      //     if (isSendAsEmail) {
      //       // Submit as email
      //       await handleNoteEmailSubmit(values, resetForm);
      //     } else {
      //       // Save as note
      //       await handleNoteSaveSubmit(values, resetForm);
      //     }
      //   },
      // });

      // const noteFormValid = useMemo(() => {
      //   return (
      //     // noteFormik.values.to !== "" &&
      //     // noteFormik.values.to !== undefined &&
      //     noteFormik.values.subject !== "" &&
      //     noteFormik.values.subject !== undefined &&
      //     stripHtmlTags(noteFormik.values.message) !=="" &&
      //     stripHtmlTags(noteFormik.values.message) !==undefined 
      //   );
      // }, [noteFormik.values.subject, noteFormik.values.message]);

    
      useEffect(() => {
        const fetchEmailLogs = async () => {
          try {
            const response = await axios.get(`${API_URL}/view-email-logs`);
            setEmailLog(response.data); // Set the fetched data to state
        
            
          } catch (error) {
            console.error("Failed to load expenses", error);
          }
        };

     
       
        fetchEmailLogs();
       
        
      }, []);

      useEffect(() => {
        if (invoiceEmailData.template) {
          const selectedTemplate = emailTemplateList.find(
            (template) => template.id === Number(invoiceEmailData.template)
          );
    
          if (selectedTemplate) {
            setInvoiceEmailData({
              ...invoiceEmailData,
              subject: selectedTemplate.subject,
              message: selectedTemplate.message,
            });
          }
        }
      }, [invoiceEmailData.template, invoiceEmailData.subject]); 
      


      useEffect(() => {
        if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
          setCurrentSearchQuery(debouncedSearchQuery);
          refetch();
        }
      }, [debouncedSearchQuery]);

      useEffect(() => {
        if (
          debouncedSearchQueryProject.length >= 4 ||
          debouncedSearchQueryProject === ""
        ) {
          setCurrentSearchQueryProject(debouncedSearchQueryProject);
          refetch();
        }
      }, [debouncedSearchQueryProject]);

      useEffect(() => {
        if (
          debouncedSearchQueryInvoice.length >= 3 ||
          debouncedSearchQueryInvoice === ""
        ) {
          setCurrentSearchQueryInvoice(debouncedSearchQueryInvoice);
          refetch();
        }
      }, [debouncedSearchQueryInvoice]);

      useEffect(() => {
        if (
          debouncedSearchQueryEmailTemplate.length >= 3 ||
          debouncedSearchQueryEmailTemplate === ""
        ) {
          setCurrentSearchQueryEmailTemplate(debouncedSearchQueryEmailTemplate);
          refetch();
        }
      }, [debouncedSearchQueryEmailTemplate]);

      useEffect(() => {
        if (
          debouncedSearchQueryNoteTemplate.length >= 3 ||
          debouncedSearchQueryNoteTemplate === ""
        ) {
          setCurrentSearchQueryNoteTemplate(debouncedSearchQueryNoteTemplate);
          refetch();
        }
      }, [debouncedSearchQueryNoteTemplate]);

      // useEffect(() => {
      //   if (customer && customer?.companyEmail || customer?.companyMobileNumber) {
      //     emailFormik.setFieldValue("to", customer?.companyEmail);
      //     textFormik.setFieldValue("to", customer?.companyMobileNumber);
      //     setInvoiceEmailData({ ...invoiceEmailData, to: customer?.companyEmail });

      //   }
      // }, [customer]);

      const handleOpenDialog = (customer: ICompanyDetails) => {
        setSelectCustomer(customer);
        setOpenDialog(true);
      };

      const handleCloseDialog = () => {
        setSelectCustomer(null);
        setOpenDialog(false);
      };

        const handleOpenDialogOnline = (customer: ICompanyDetails) => {
        setSelectOnline(customer);
        setOpenDialogOnline(true);
      };

      const handleCloseDialogOnline = () => {
        setSelectOnline(null);
        setOpenDialogOnline(false);
      };

      const handleOpenAddTransaction = () => {
        setTransactionData(undefined);
        setOpenAddTransaction(true);
      };

      const handleCloseAddTransaction = () => {
        setTransactionData(undefined);
        setOpenAddTransaction(false);
      };

      const handleOpenAddProject = () => {
        setProjecData(undefined);
        setOpenAddProject(true);
      };

      const handleCloseAddProject = () => {
        setProjecData(undefined);
        setOpenAddProject(false);
      };

      const handleOpenViewInvoice = (transactionId: string) => {
        setInvoiceId(transactionId);
        setOpenViewInvoice(true);
        //console.log(transactionId);
      };

      const handleOpenViewQuote = (transactionId: string) => {
        setQuoteId(transactionId);
        setOpenViewQuote(true);
        //console.log(transactionId);
      };
      
      

      const handleCloseViewInvoice = () => {
        setOpenViewInvoice(false);
        setInvoiceId("");
      };

      const handleCloseViewQuote = () => {
        setOpenViewQuote(false);
        setQuoteId("");
      };

      const handleOpenAddWorkOrder = () => {
        setWorkOrderData(undefined);
        setOpenAddWorkOrder(true);
      };

      const handleCloseAddWorkOrder = () => {
        setWorkOrderData(undefined);
        setOpenAddWorkOrder(false);
      };

      // const handleOpenEditSuites = () => {
      //   setSelectCustomer(customer);
      //   setOpenDialog(true);
      // };

      const handleQuotesToggle = () => {
        setShowProject(false);
        setShowQuotes(true);
        setShowInvoice(false);
        setShowEmailForm(false); // Ensure email is hidden
        setShowNoteForm(false); 
        setShowTextForm(false); 
      };

      const handleInvoiceToggle = () => {
        setShowProject(false);
        setShowInvoice(true);
        setShowEmailForm(false); // Ensure email is hidden
        setShowNoteForm(false); 
        setShowTextForm(false); 
        setShowQuotes(false); 
      };

      const handleInfoToggle = () => {
        setShowProject(true);
        setShowTime(false);
        setShowOnline(false);
        setShowInvoice(false);
        setShowEmailForm(false); // Ensure email is hidden
        setShowNoteForm(false); 
        setShowTextForm(false);
        setShowQuotes(false);  
      };

       const handleTimingToggle = () => {
        setShowTime(true);
        setShowProject(false);
        setShowOnline(false);
        setShowInvoice(false);
        setShowEmailForm(false); // Ensure email is hidden
        setShowNoteForm(false); 
        setShowTextForm(false);
        setShowQuotes(false);  
        
      };

        const handleOnlineToggle = () => {
        setShowOnline(true);
        setShowTime(false);
        setShowProject(false);
        setShowInvoice(false);
        setShowEmailForm(false); // Ensure email is hidden
        setShowNoteForm(false); 
        setShowTextForm(false);
        setShowQuotes(false);  
      };

      // Toggle Email
      const handleEmailToggle = () => {
        setShowEmailForm(true);
        setShowInvoice(false);
        setShowProject(false); // Ensure project is hidden
        setShowNoteForm(false); 
        setShowTextForm(false);
        setShowQuotes(false);  
      };

      const handleTextToggle = () => {
        setShowEmailForm(false);
        setShowInvoice(false);
        setShowProject(false); // Ensure project is hidden
        setShowNoteForm(false); 
        setShowTextForm(true); 
        setShowQuotes(false); 
      };

      const handleNoteToggle = () => {
        setShowEmailForm(false);
        setShowInvoice(false);
        setShowProject(false); // Ensure project is hidden
        setShowNoteForm(true); 
        setShowTextForm(false); 
        setShowQuotes(false); 
      };
      

      if (isLoading || customerDataIsLoading) {
        return (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="10vh"
          >
            <CircularProgress />
          </Box>
        );
      }

      if (isError) {
        return (
          <Typography color="error">
            Error fetching customer data. Please try again later.
          </Typography>
        );
      }

      if (!customer) {
        return <Typography>No customer data available.</Typography>;
      }
      const handleOpenDeletePopup = (coursing: ICustomerTransaction) => {
        setCoursingToDelete(coursing);
        setOpenDeleteCategory(true);
      };

      const handleCloseDeletePopup = () => {
        setCoursingToDelete(null);
        setOpenDeleteCategory(false);
      };

      const handleDelete = async (id: string) => {
        try {
          const response = await deleteCategory(id).unwrap();
          if (response.status) {
            showMessage("Deleted successfully");
            setOpenDeleteCategory(false);
          } else {
            showErrorMessage("Failed to delete the customer");
          }
        } catch (error) {
          showErrorMessage("Failed to delete the customer");
        }
      };

      const handleOpenDeleteProjectPopup = (project: ICustomerProject) => {
        setProjectToDelete(project);
        setOpenDeleteProject(true);
      };

      const handleCloseDeleteProjectPopup = () => {
        setProjectToDelete(null);
        setOpenDeleteProject(false);
      };

      const handleDeleteProject = async (id: string) => {
        try {
          const response = await deleteProject(id).unwrap();
          if (response.status) {
            showMessage("Deleted successfully");
            setOpenDeleteProject(false);
            const refetchResult = await refetchActivityHistory();
          } else {
            showErrorMessage("Failed to delete the customer project");
          }
        } catch (error) {
          showErrorMessage("Failed to delete the customer project");
        }
      };

      const handleOpenDeleteWrokOrderPopup = (project: IQuoteWorkOrder) => {
        setProjectWrokOrderToDelete(project);
        setOpenDeleteProjectWrokOrder(true);
      };

      const handleCloseDeleteWrokOrderPopup = () => {
        setProjectWrokOrderToDelete(null);
        setOpenDeleteProjectWrokOrder(false);
      };

      const handleDeleteWrokOrder = async (id: string) => {
        try {
          const temData = {
            id: id,
            quoteWorkOrderCustomerId: String(customerId),
          };
          const response = await newCustomer(temData).unwrap();

          if (response.status) {
            showMessage("Deleted successfully");
            setOpenDeleteProjectWrokOrder(false);
          } else {
            showErrorMessage("Failed to remove the customer project work order");
          }
        } catch (error) {
          showErrorMessage("Failed to remove the customer project remove");
        }
      };

      const emailLogs = activityHistoryData?.data?.emailLogs || [];
      const smsLogs = activityHistoryData?.data?.smsLogs || [];
      const noteLogs = activityHistoryData?.data?.noteLogs || [];
      const notes = activityHistoryData?.data?.notes || [];
      const projectLogs = activityHistoryData?.data?.projectLogs || []; // Assuming you have this array
      const processedWorkOrderIds = new Set(); 
    
      const combinedLogs = [
        ...emailLogs.map((log) => ({
          ...log,
          type: "Email Sent",
        })),
        ...smsLogs.map((log) => ({
          ...log,
          type: "Sms Sent",
        })),
        ...noteLogs.map((log) => ({
          ...log,
          type: "Note Email Sent",
        })),
        ...notes.map((log) => ({
          ...log,
          type: "Note Saved",
        })),

        ...(workOrderHistoryData &&
          Array.isArray(workOrderHistoryData.data) &&
          workOrderHistoryData.data.length > 0
            ? workOrderHistoryData.data.map((log, workOrderIndex) => {
              // const type =
              // workOrderIndex === 0
              // ? "Work order created"
              // : log.isInvoice
              // ? "Work order converted to invoice"
              // : "Work order edited";
              let type = "";
             
              if (!processedWorkOrderIds.has(log.work_order_id)) {
                type = "Work order created";
                processedWorkOrderIds.add(log.work_order_id);
              } else if (log.isInvoice) {
                type = "Work order converted to invoice";
              } else {
                type = "Work order edited";
              }
            
        return {
          ...log,
          type, // Use the determined type
          workOrderIndex,
        };
      })
      : []),



        ...projectLogs.map((log) => {
          // Determine the type based on the action performed
          let type = "Project Created"; // Default to Created
          if (log.action === "updated") {
            type = "Project Updated";
          } else if (log.action === "deleted") {
            type = "Project Deleted";
          }
          return {
            ...log,
            type, // Use the determined type
          };
        }),
      ];

      const sortedCombinedLogs = combinedLogs.sort((a, b) => {
        const dateA = new Date(a.created_at).getTime();
        const dateB = new Date(b.created_at).getTime();
        return dateB - dateA; // Sort descending
      });
      
      // Create timeLineSteps from sorted logs
      const timeLineSteps = sortedCombinedLogs.map((log, index) => {
        let description;
      
        if (log.type === "Sms Sent") {
          description = `Message | ${log.message || 'N/A'}`; // Customize description for SMS
        }else if (log.type.startsWith("Project")) {
        
          if (log.type === "Project Created") {
            description = `Project '${log.project_name}' has been created `;
        } else if (log.type === "Project Updated") {
            description = `Project '${log.project_name}' has been updated`;
        } else if (log.type === "Project Deleted") {
            description = `Project '${log.project_name}'  has been deleted`;
        }  
       } else if  (log.type.startsWith("Work order")) {
          // description = `Work order '${log.quoteWorkOrderNo}' has been created `;
 
              description = (
               <div>
                 
                 {log.type === "Work order created" && (
                 // {log.workOrderIndex  === 0 && (
                   <div>
                      <Typography variant="body1">
                     <strong>Work Order No. :</strong> {log.quoteWorkOrderNo}
                   </Typography>
                     <Typography variant="body1">
                       <strong>Created by :</strong> {log.updated_by}
                     </Typography>
                     <Typography variant="body1">
                       <strong>Created at :</strong>{" "}
                       {log?.created_at
                         ? dayjs(log.created_at).format("MMM D, YYYY [at] h:mm A")
                         : ""}
                     </Typography>
                   </div>
                 )}
                   {log.type === "Work order converted to invoice" && (
                 //{log.isInvoice == true && (
                   <div>
                     <Typography variant="body1">
                       <strong>Invoice Number :</strong> {log.InvoiceNo}
                     </Typography>
                     <Typography variant="body1">
                       <strong>Converted by :</strong> {log.updated_by}
                     </Typography>
                     <Typography variant="body1">
                       <strong>Converted at :</strong>{" "}
                       {log?.created_at
                         ? dayjs(log.created_at).format("MMM D, YYYY [at] h:mm A")
                         : ""}
                     </Typography>
                     <Grid item textAlign={"end"} justifyContent={"flex-end"}>
                       <Button
                         variant="contained"
                         startIcon={<VisibilitySharpIcon />}
                         className={classes.addButton}
                         onClick={() =>
                           navigate(
                             `/invoice/history/${log?.invoiceId}`
                           )
                         }
                       >
                         Invoice
                       </Button>
                     </Grid>
                   </div>
                 )}
                 {/* {log.isInvoice == false && log.workOrderIndex != 0 && ( */}
                   {log.isInvoice == false && log.type === "Work order edited" && (
                   <div>
                      <Typography variant="body1">
                     <strong>Work Order No. :</strong> {log.quoteWorkOrderNo}
                   </Typography>
                     <Typography variant="body1">
                       <strong>Edited by :</strong> {log.updated_by}
                     </Typography>
                     <Typography variant="body1">
                       <strong>Edited at :</strong>{" "}
                       {log?.updated_at
                         ? dayjs(log.updated_at).format("MMM D, YYYY [at] h:mm A")
                         : ""}
                     </Typography>
                   </div>
                 )}
                 <Typography variant="body1"> </Typography>
                 <TableContainer sx={{ marginTop: 2 }}>
                   <Table className={classes.table}>
                     <TableHead className={classes.tableHeaderRow}>
                       <TableRow>
                         <TableCell className={classes.tablheader}>
                           <strong>Product</strong>
                         </TableCell>
                        
                         <TableCell
                           className={classes.tablheader}
                           sx={{ textAlign: "right" }}
                         >
                           <strong>Price</strong>
                         </TableCell>
                         <TableCell
                           className={classes.tablheader}
                           sx={{ textAlign: "right" }}
                         >
                           <strong>Tax</strong>
                         </TableCell>
                      
                         <TableCell
                           className={classes.tablheader}
                           sx={{ textAlign: "right" }}
                         >
                           <strong>Total</strong>
                         </TableCell>
                       </TableRow>
                     </TableHead>
                     <TableBody>
                       {workOrderError || log.quoteWorkOrderSale.length === 0 ? (
                         <TableRow>
                           <TableCell colSpan={8} align="center">
                             {workOrderError
                               ? "Error fetching data"
                               // : "No data available"
                               :""
                               }
                           </TableCell>
                         </TableRow>
                       ) : (
                         log.quoteWorkOrderSale.map(
                           (
                             row: IProduct,
                             index: number 
                           ) => (
                             <TableRow key={index} className={classes.tableRowHover}>
                               <TableCell scope="row" className={classes.tablCell}>
                                 {row.productName}
                               </TableCell>
                               {/* <TableCell className={classes.tablCell} align="right">
                                 {row.quantity}
                               </TableCell> */}
                               <TableCell className={classes.tablCell} align="right">
                                 {row.price !== null && row.price !== undefined
                                   ? row.price.toFixed(2)
                                   : "0.00"}
                               </TableCell>
                               <TableCell className={classes.tablCell} align="right">
                                 {/* {row.tax}% */}
                                 {row.taxAmount}
                               </TableCell>
                               {/* <TableCell className={classes.tablCell} align="right">
                                 {(row.unitPriceWithDiscount ?? 0).toFixed(2)}
                               </TableCell> */}
                               <TableCell className={classes.tablCell} align="right">
                                 {row.unitTotalWithDiscount != null
                                   ? row.unitTotalWithDiscount.toFixed(2)
                                   : "0.00"}
                               </TableCell>
                             </TableRow>
                           )
                         )
                       )}
                     </TableBody>
                   </Table>
                 </TableContainer>
                 <Grid container>
                   {workOrderError ||
                   log.quoteWorkOrderSaleDiscountDescription.length === 0 ? (
                     <Grid item lg={12} md={12} sm={12} xs={12}>
                       {workOrderError ? "Error fetching data" 
         
                         // : "No data available"
                               :""
                       }
                     </Grid>
                   ) : (
                     log.quoteWorkOrderSaleDiscountDescription.map(
                       (discount: IDiscount, index: number) => (
                         <Grid item lg={12} md={12} sm={12} xs={12} key={index}>
                           <Grid
                             container
                             spacing={2}
                             display={"end"}
                             justifyContent={"flex-end"}
                           >
                             <Grid
                               item
                               lg={2}
                               md={2}
                               sm={4}
                               xs={8}
                               textAlign={"end"}
                             >
                               <Typography>
                                 {discount.description || "Discount"}
                                 {" :"}
                               </Typography>
                             </Grid>
                             <Grid
                               item
                               lg={2}
                               md={2}
                               sm={2}
                               xs={4}
                               textAlign={"end"}
                             >
                               <Typography>
                                 {"$"}
                                 {(discount.value ?? 0).toFixed(2)}
                               </Typography>
                             </Grid>
                           </Grid>
                         </Grid>
                       )
                     )
                   )}
                   <Grid item lg={12} md={12} sm={12} xs={12}>
                     <Grid
                       container
                       spacing={2}
                       display={"end"}
                       justifyContent={"flex-end"}
                     >
                       <Grid
                         item
                         lg={2}
                         md={2}
                         sm={4}
                         xs={8}
                         textAlign={"end"}
                         className={classes.tablCell}
                       >
                         <Typography>Total Discount :</Typography>
                       </Grid>
                       <Grid
                         item
                         lg={2}
                         md={2}
                         sm={2}
                         xs={4}
                         textAlign={"end"}
                         className={classes.tablCell}
                       >
                         <Typography>
                           {"$"}
                           {Number(log.quoteWorkOrderDiscount || 0).toFixed(2)}
                         </Typography>
                       </Grid>
                     </Grid>
                   </Grid>
                   <Grid item lg={12} md={12} sm={12} xs={12}>
                     <Grid
                       container
                       spacing={2}
                       display={"end"}
                       justifyContent={"flex-end"}
                     >
                       <Grid item lg={2} md={2} sm={4} xs={8} textAlign={"end"}>
                         <Typography style={{fontWeight:'bold'}}>
                           Grand Total :
                         </Typography>
                       </Grid>
                       <Grid item lg={2} md={2} sm={2} xs={4} textAlign={"end"}>
                         <Typography style={{fontWeight:'bold'}} >
                           {"$"}
                           {Number(log.quoteWorkOrderSaleGrandTotal || 0).toFixed(
                             2
                           )}
                         </Typography>
                       </Grid>
                     </Grid>
                   </Grid>
                 </Grid>
               </div>
             );
 

        } else {
          description = `Subject | ${log.subject || 'No Subject'}`; // Default for emails and note emails
        }
      
        return {
          key: `${log.type}-${log.created_at}-${log.id || index}`,
          label: log.type,
          description, // Use the customized description
          date: new Date(log.created_at).toLocaleDateString(),
          time: new Date(log.created_at).toLocaleTimeString(),
        };
      });

     

      const toggleStepDetails = (index: number) => {
        if (expandedSteps.includes(index)) {
          setExpandedSteps(
            expandedSteps.filter((stepIndex) => stepIndex !== index)
          );
        } else {
          setExpandedSteps([...expandedSteps, index]);
        }
      };

      const convertPlainTextToHTML= (text: string) => {
        return text
          .replace(/\n/g, '<br>') // Replace line breaks with <br>
          .replace(/ {2,}/g, match => '&nbsp;'.repeat(match.length)); // Replace multiple spaces with &nbsp;
      }
      const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsSendAsEmail(event.target.checked); // Toggle the state when switch is changed
      };
    


      const handleGeneratePDF = async (TransactionType: any) => {
        const input = invoiceRef.current;
      
       
        if (input) {
          console.log("Captured Element:", input); // Log to check if the element is being captured correctly
         const canvas = await html2canvas(input, {
  scale: 2, // Reduce scale for lower resolution
  logging: false, // Disable logging for performance
  useCORS: true,
});

          const imgData = canvas.toDataURL('image/png');
          const pdf = new jsPDF('p', 'mm', 'a4');
      
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();
      
          pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
          //pdf.save("generated-invoice.pdf");
          // return <img src={imgData} alt="Captured Invoice" />;
           //console.log(imgData)
          return pdf.output('blob');
        } else {    
          throw new Error('Invoice element not found');
        }
      };
      
  
 const totalSales = invoiceList.length;

 const totalAmount = invoiceList.reduce((sum, invoice) => {
  const amount = parseFloat(invoice.quoteWorkOrderSaleGrandTotal || "0");
  return sum + (isNaN(amount) ? 0 : amount);
}, 0);


  const lastSaleDate = invoiceList
    .map((invoice) => invoice.created_at)
    .filter(Boolean)
    .sort((a, b) => new Date(b).getTime() - new Date(a).getTime())[0];


      return (
        <div>
          <Grid container spacing={3}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card} >
 


                    <Grid container spacing={2}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className={classes.profileBottomSetUp}
                      >
                        <Grid className={classes.profileBottomDwon}>
                          {customer?.driverImg ? (
                            <img
                       
                              src={`${LARAVEL_API_URL}/${customer?.driverImg}`}
                              alt="Profile"
                              className={classes.SelectImageTable}
                                style={{
    border: "1px solid #ddd",
    // borderRadius: "8px",
    // backgroundColor: "#fff",
    // padding: "4px",
  }}
                            />
                          ) : (
                            <Avatar className={classes.profileImage} />
                          )}
                        </Grid>

                        <Grid className={classes.profileDetails}>
                          <Typography
                            variant="h4"
                            className={classes.profileDetailItem}
                          >
                            {(customer?.driverFirstName || "")} {(customer?.driverLastName || "")}
         {customer?.driverUserRole && (
  <Box
    sx={{
      position: "absolute",
      top: 15,
      right: 12,
      bgcolor: "#1976d2", 
      color: "#fff",
      px: 2,
      py: 0.5,
      borderRadius: "16px",
      fontWeight: 700,
      fontSize: 12,
      textTransform: "uppercase",
      boxShadow: "0 3px 8px rgba(0,0,0,0.2)",
      zIndex: 10,
    }}
  >
    {customer.driverUserRole.replace("_", " ")}
  </Box>
)}

                        
                          </Typography>

                          <Typography
                            variant="body1"
                            className={classes.contactInfo}
                          >
                            <span className={classes.iconText}>
                              <PhoneIcon /> {customer?.driverMobileNum}
                            </span>

                            <span className={classes.iconText}>
                              <EmailIcon /> {customer?.driverEmail}
                            </span>
                          </Typography>
                          <Grid className={classes.buttonGroup}>
                            <div className={classes.buttonItem}>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.editButtonProfile}
                                onClick={handleInfoToggle}
                              >
                               <InfoIcon />
                              </Button>
                              <Typography className={classes.buttonLabel}>
                                Info
                              </Typography>
                            </div>
                              <div className={classes.buttonItem}>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.editButtonProfile}
                                onClick={handleTimingToggle}
                              >
                               <AccessTimeIcon />
                              </Button>
                              <Typography className={classes.buttonLabel}>
                                Timing
                              </Typography>
                            </div>
                             <div className={classes.buttonItem}>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.editButtonProfile}
                                onClick={handleOnlineToggle}
                              >
                               <LanguageIcon />
                              </Button>
                              <Typography className={classes.buttonLabel}>
                                Pwd
                              </Typography>
                            </div>
                             {/* <div className={classes.buttonItem}>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.editButtonProfile}
                                onClick={handleInfoToggle}
                              >
                                 <PointOfSaleIcon />
                              </Button>
                              <Typography className={classes.buttonLabel}>
                                Cash Out
                              </Typography>
                            </div> */}

                            {/* <div className={classes.buttonItem}>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.editButtonProfile}
                                onClick={handleQuotesToggle}
                              >
                                <DescriptionIcon />
                              </Button>
                              <Typography className={classes.buttonLabel}>
                                Quotes
                              </Typography>
                            </div>

                            <div className={classes.buttonItem}>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.editButtonProfile}
                                onClick={handleInvoiceToggle}
                              >
                                <DescriptionIcon />
                              </Button>
                              <Typography className={classes.buttonLabel}>
                                Invoice
                              </Typography>
                            </div>

                            <div className={classes.buttonItem}>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.editButtonProfile}
                                onClick={handleEmailToggle}
                              >   
                                <EmailIcon />
                              </Button>
                              <Typography className={classes.buttonLabel}>
                                Email
                              </Typography>
                            </div>

                            <div className={classes.buttonItem}>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.editButtonProfile}
                          
                              >   
                                <PhoneIcon />
                              </Button>
                              <Typography className={classes.buttonLabel}>
                                Call
                              </Typography>
                            </div>

                            <div className={classes.buttonItem}>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.editButtonProfile}
                                onClick={handleTextToggle}
                              >
                                <ChatIcon />
                              </Button>
                              <Typography className={classes.buttonLabel}>
                                Text
                              </Typography>
                            </div>

                            <div className={classes.buttonItem}>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.editButtonProfile}
                                onClick={handleNoteToggle}
                              >
                                <NoteIcon />
                              </Button>
                              <Typography className={classes.buttonLabel}>
                                Note
                              </Typography>
                            </div>

                            <div className={classes.buttonItem}>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.editButtonProfile}
                              >
                                <HistoryIcon />
                              </Button>
                              <Typography className={classes.buttonLabel}>
                                History
                              </Typography>
                            </div> */}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                {showProject && (
                  <>
                 <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                                 <Card className={classes.stepperCard}>
                                   <Grid container>
                                     <Grid item lg={12} md={12} sm={12} xs={12}>
                                       <Grid container spacing={2}>
                                         <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                                           <Grid
                                             container
                                             justifyContent={"space-between"}
                                             spacing={5}
                                             sx={{ borderBottom: 2, padding: 2 }}
                                             className={classes.titleGrid}
                                           >
                                             <Grid
                                               item
                                               lg={8}
                                               md={8}
                                               sm={8}
                                               xs={8}
                                               pt={2}
                                               alignContent={"center"}
                                             >
                                               <Typography className={classes.cardTitle}>
                                                 User Details
                                               </Typography>
                                             </Grid>
                                           </Grid>
                                         </Grid>
                 
                                         <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                                           <Grid
                                             container
                                             justifyContent={"space-between"}
                                             spacing={5}
                                             sx={{ borderBottom: 2, px: 2 }}
                                             className={classes.titleGrid}
                                           >
                                             <Grid
                                               item
                                               lg={4}
                                               md={4}
                                               sm={4}
                                               xs={4}
                                               pt={2}
                                               alignContent={"center"}
                                               direction={"column"}
                                             >
                                               <Typography variant="subtitle1">
                                                 <span className={classes.customerDetails}>
                                                   User Name
                                                 </span>{" "}
                                               </Typography>
                                             </Grid>
                                             <Grid
                                               item
                                               lg={8}
                                               md={8}
                                               sm={8}
                                               xs={8}
                                               pt={2}
                                               alignContent={"center"}
                                               direction={"column"}
                                             >
                                               <Typography variant="subtitle1">
                                               {customer?.driverUserName}
                                               </Typography>
                                             </Grid>
                                           </Grid>
                                         </Grid>

                                          <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                                            <Grid
                                             container
                                             justifyContent={"space-between"}
                                             spacing={5}
                                             sx={{ borderBottom: 2, px: 2 }}
                                             className={classes.titleGrid}
                                           >
                                             <Grid
                                               item
                                               lg={4}
                                               md={4}
                                               sm={4}
                                               xs={4}
                                               pt={2}
                                               alignContent={"center"}
                                               direction={"column"}
                                             >
                                               <Typography variant="subtitle1">
                                                 <span className={classes.customerDetails}>
                                                   Alt Phone No.
                                                 </span>{" "}
                                               </Typography>
                                             </Grid>
                                             <Grid
                                               item
                                               lg={8}
                                               md={8}
                                               sm={8}
                                               xs={8}
                                               pt={2}
                                               alignContent={"center"}
                                               direction={"column"}
                                             >
                                               {customer?.driverAltMobileNum || "-"}
                                             </Grid>
                                           </Grid>
                                         </Grid>

                                          <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                                           <Grid
                                             container
                                             justifyContent={"space-between"}
                                             spacing={5}
                                             sx={{ borderBottom: 2, px: 2 }}
                                             className={classes.titleGrid}
                                           >
                                             <Grid
                                               item
                                               lg={4}
                                               md={4}
                                               sm={4}
                                               xs={4}
                                               pt={2}
                                               alignContent={"center"}
                                               direction={"column"}
                                             >
                                               <Typography variant="subtitle1">
                                                 <span className={classes.customerDetails}>
                                                   Address
                                                 </span>{" "}
                                               </Typography>
                                             </Grid>
                                             <Grid
                                               item
                                               lg={8}
                                               md={8}
                                               sm={8}
                                               xs={8}
                                               pt={2}
                                               alignContent={"center"}
                                               direction={"column"}
                                             >
                                               {/* <Typography variant="subtitle1">
  {[customer?.companyStreetNumber,
    customer?.companyStreetName,
    customer?.companyCity,
    customer?.companyProvince,
    customer?.companyPostalCode
  ]
    .filter(Boolean)
    .join(", ") || "—"}
</Typography> */}

 <Typography variant="subtitle1">
  {customer?.driverAddress|| "-"}
</Typography>

                                             </Grid>
                                           </Grid>
                                         </Grid>
                 
                                        
                 
                                         <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                                           <Grid
                                             container
                                             justifyContent={"space-between"}
                                             spacing={5}
                                             sx={{ px: 2, pb: 2 }}
                                             className={classes.titleGrid}
                                           >
                                             <Grid
                                               item
                                               lg={4}
                                               md={4}
                                               sm={4}
                                               xs={4}
                                               pt={2}
                                               alignContent={"center"}
                                               direction={"column"}
                                             >
                                               <Typography variant="subtitle1">
                                                 <span className={classes.customerDetails}>
                                                  Description
                                                 </span>{" "}
                                               </Typography>
                                             </Grid>
                                             <Grid
                                               item
                                               lg={8}
                                               md={8}
                                               sm={8}
                                               xs={8}
                                               pt={2}
                                               alignContent={"center"}
                                               direction={"column"}
                                             >
                                               <Typography variant="subtitle1">
                                                 {customer?.driverDescription || "-"}
                                               </Typography>
                                             </Grid>
                                           </Grid>
                                         </Grid>
                 
                 
                 
                                        
                 
                                        
                                       </Grid>
                                     </Grid>
                                   </Grid>
                                 </Card>
                               </Grid>
                               

                    {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Typography className={classes.cardTitle}>
                              Invoices
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                            <Grid
                              container
                              spacing={1}
                              justifyContent="flex-end"
                              sx={{ display: "flex" }}
                            >
                              <Grid item>
                                <TextField
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <CiSearch
                                          className={classes.searchWidgetIcon}
                                        />
                                      </InputAdornment>
                                    ),
                                    classes: {
                                      root: classes.formControlList,
                                    },
                                  }}
                              fullWidth
                              value={searchQueryInvoice}
                              onChange={(e) =>
                                setSearchQueryInvoice(e.target.value)
                              }
                              placeholder="Name .."
                              sx={{ width: "100%" }}
                              size="small"
                            />
                          </Grid>

                          <Grid item>
                            <Button
                              variant="contained"
                              className={classes.addButton}
                              onClick={() =>
                                navigate(`/invoice/create/${customerId}`)
                              }
                            >
                              Add Invoice
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid>
                      <TableContainer>
                        <Table className={classes.table}>
                          <TableHead className={classes.tableHeaderRow}>
                            <TableRow>
                          
                              <TableCell className={classes.tablheader}>
                                <strong>Invoice No</strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Status</strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Amount</strong>
                              </TableCell>
                                <TableCell className={classes.tablheader}>
                                                <strong>Paid Amt</strong>
                                              </TableCell>
                                              <TableCell className={classes.tablheader}>
                                                <strong>Balance</strong>
                                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Issue From </strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Create Date</strong>
                              </TableCell>
                            
                              <TableCell
                                className={classes.tablheader}
                                sx={{ textAlign: "right" }}
                              >
                                <strong>Actions</strong>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {invoiceList.map((transaction) => {
                                const statusLabel = getStatusLabel(transaction.quoteWorkOrderStatus);
                                const statusColor = getStatusColor(transaction.quoteWorkOrderStatus);
                               
                                  const balance = Math.max(0, parseFloat(transaction.quoteWorkOrderSaleGrandTotal || "0") - parseFloat(String(transaction.amount_paid || "0")));
                                return(
                              <TableRow
                                key={transaction.id}
                                className={classes.tableRowHover}
                              >
                              
                              <TableCell
                                  component="th"
                                  scope="row"
                                  className={classes.tablCell}
                                  sx={{ whiteSpace: "nowrap", cursor: "pointer" }}
                                  onClick={() => navigate(`/work-order/history/${transaction.work_order_id}`)}
                                >
                                  {transaction.InvoiceNo}
     {balance > 0 && (                                 
<a
  href={`/work-order/history/${transaction.work_order_id}`}
  rel="noopener noreferrer"
  style={{
    backgroundColor: '#007BFF',
    color: '#fff',
    borderRadius: '6px',
    padding: '2px 8px',
    marginLeft: '8px',
    fontSize: '0.7rem',
    fontWeight: '500',
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-block',
  }}
>
  Pay
</a>
)}
                                </TableCell>

                                <TableCell scope="row" className={classes.tablCell}>
                                                        <Button
                                                             className={classes.statusButtonList}
                                                            style={{
                                                        color: statusColor,
                                                          backgroundColor: transaction.quoteWorkOrderStatus === WorkOrderStatus.Paid
                                                       ? "#e1f8d5"
                                                      : transaction.quoteWorkOrderStatus === WorkOrderStatus.Cancel
                                                      ? "#f8d7da"
                                                      : transaction.quoteWorkOrderStatus === WorkOrderStatus.Pending
                                                       ? "lightyellow"
                                                        : transaction.quoteWorkOrderStatus === WorkOrderStatus.Initiated
                                                        ? "#e2fafa"
                                                        : "#ffffff", // Fallback for other statuses
                                                        border: "solid 1px",
                                                        borderColor: statusColor,
                                                        borderRadius: "8px",
                                                                                      
                                                         }}
                                                           >
                                                           {statusLabel}
                                                            </Button>
                                                       </TableCell>
                                                       <TableCell
                                  component="th"
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  {"$"}
                                  {parseFloat(
                                    transaction?.quoteWorkOrderSaleGrandTotal ||
                                      "0"
                                  ).toFixed(2)}
                                </TableCell>

                                      <TableCell  component="th" scope="row"  className={classes.tablCell}>
                                                            {"$"}{(transaction.amount_paid || "0" )}
                                                        </TableCell>
                                                       
                                                        <TableCell component="th" scope="row" className={classes.tablCell}>
                                                         {"$"}{balance.toFixed(2)}
                                                         </TableCell>

                                  <TableCell scope="row" className={classes.tablCell}>
                                 {transaction?.company.companyName || transaction?.project.projectName || ""}
                                </TableCell>

                                <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  {transaction?.created_at
                                    ? dayjs(transaction.created_at).format(
                                        "MMM D, YYYY [at] h:mm A"
                                      )
                                    : ""}
                                </TableCell>
                                

                                <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  <Grid
                                    container
                                    spacing={1}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                
                                 
                                    <Grid item>


                                      
                                      <Button
                                        variant="contained"
                                        
                                        className={classes.viewButtonList}
                                        onClick={() => handleOpenViewInvoice(String(transaction.id))}
                                        // onClick={() =>
                                        //   navigate(
                                        //     `/invoice/history/${transaction.id}`
                                        //   )
                                        // }
                                      >
                                        <VisibilitySharpIcon
                                          className={classes.viewListIcon}
                                        />
                                      </Button>
                                    </Grid>
                               

                                    <Grid item>
                          <Button
  variant="contained"
  className={classes.editButtonList}
  onClick={() =>
    navigate(
      transaction.project?.id
        ? `/invoice/project/edit/${transaction.id}` 
        : `/invoice/edit/${transaction.id}` 
    )
  }
>
  <EditSharpIcon className={classes.editListIcon} />
</Button>

</Grid>

                                  </Grid>
                                </TableCell>
                              </TableRow>
                              )
})}
                          </TableBody>
                        </Table>
                      </TableContainer>


                 

                       {openViewInvoice && (
                     
  <Dialog open={openViewInvoice} onClose={handleCloseViewInvoice} maxWidth="md" fullWidth
  >
    <DialogTitle><Typography variant="h5" component="div">
    Invoice Details
  </Typography></DialogTitle>
    <DialogContent >
   
    <ViewInvoice invoiceId={invoiceId} type="view"/>
   
    </DialogContent>
    <DialogActions>
      <Button onClick={handleCloseViewInvoice}>Close</Button>
    </DialogActions>
  </Dialog>


)} 


                 {openViewInvoice && (
                        <ViewInvoice
                          openModel={openViewInvoice}
                          handleCloseDialog={handleCloseViewInvoice}
                          invoiceId={invoiceId}
                        />
                      )} */}
{/* 
                      {selectCustomer && (
                        <NewCompanyPopUp
                          openModel={openDialog}
                          handleCloseDialog={handleCloseDialog}
                          data={selectCustomer}
                        />
                      )}  */}
                  {/* {openAddTransaction && (
                        <NewCustomerTransactionPopUp
                          openModel={openAddTransaction}
                          handleCloseDialog={handleCloseAddTransaction}
                          data={transactionData}
                          customerId={customerId}
                        />
                      )} 
                      {coursingToDelete && (
                        <DeletePopup
                          open={openDeleteCategory}
                          handleCloseDelete={handleCloseDeletePopup}
                          onConfirm={async () => {
                            await handleDelete(coursingToDelete.id.toString());
                          }}
                          title="Delete Customer"
                          content={`Are you sure you want to delete "${coursingToDelete.transactionName}"?`}
                        />
                      )}
                    </Grid>
                  </Card>
                </Grid>  */}

                    
                    </>

                    
                  )}
{showTime && (
  <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
    <Card className={classes.stepperCard}>
      <Grid container>
        {/* Card Header */}
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Grid
            container
            justifyContent="space-between"
            spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
            <Grid
              item
              lg={8}
              md={8}
              sm={8}
              xs={8}
              pt={2}
              alignContent="center"
            >
              <Typography className={classes.cardTitle}>
                Available Time Slots
              </Typography>
            </Grid>
             {/* <Grid item>
                        <Button
                                                     variant="contained"
                                                     className={classes.addButton}
                                                     onClick={() => handleOpenDialog(customer)}
                                                   >
                                                    Add
                                                   </Button>
                     </Grid> */}
          </Grid>
        </Grid>







        

        {/* Days & Times */}
        <Grid item lg={12} md={12} sm={12} xs={12} >
          <Grid
            container
            justifyContent="space-between"
          //  spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
      {customer.availability && customer.availability.length > 0 ? (
                <Grid item lg={9} md={9} sm={12} xs={12}>
                  <Card className={classes.card}>
                    {/* <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={4}
                        md={4}
                        sm={4}
                        xs={4}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Available Time Slots
                        </Typography>
                      </Grid>
                    </Grid> */}
      
                    <Grid container spacing={3} p={"24px"}>
                    {customer.availability.length > 0 ? (
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.card}>
              <Grid container spacing={3} p={"24px"}>
                
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.tablheaderCreate}>
                          <strong>Day</strong>
                        </TableCell>
                        <TableCell className={classes.tablheaderCreate}>
                          <strong>Start Time</strong>
                        </TableCell>
                        <TableCell className={classes.tablheaderCreate}>
                          <strong>End Time</strong>
                        </TableCell>
                        <TableCell className={classes.tablheaderCreate}>
                          <strong>Hourly Salary</strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                    {customer.availability.map((day) =>
                        day.timeSlots.map((slot, slotIndex) => {
                          // Check if time or hourly salary is unavailable or 0.00
                          const isUnavailable = !slot.startTime || !slot.endTime || (typeof slot.hourlySalary === "number" && slot.hourlySalary === 0);
      
                          return (
                            <TableRow key={slotIndex}>
                              <TableCell className={classes.tablCell}>{day.day}</TableCell>
                              <TableCell className={classes.tablCell}>
                                {isUnavailable ? "N/A" : moment(slot.startTime, 'HH:mm').format('hh:mm A')}
                              </TableCell>
                              <TableCell className={classes.tablCell}>
                                {isUnavailable ? "N/A" : moment(slot.endTime, 'HH:mm').format('hh:mm A')}
                              </TableCell>
                              <TableCell className={classes.tablCell}>
                                {isUnavailable ? "N/A" : `$${Number(slot.hourlySalary).toFixed(2)}`}
                              </TableCell>
                            </TableRow>
                          );
                        })
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      ) : (
        <div>No availability data to show</div>
      )}
      
                    </Grid>
                  </Card>
                  
                </Grid>
              ) : (
                <div>No availability data to show</div>
              )}

          </Grid>
        </Grid>
      </Grid>
    </Card>
  </Grid>
)}


{showOnline && (
  <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
    <Card className={classes.stepperCard}>
      <Grid container>
        {/* Card Header */}
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Grid
            container
            justifyContent="space-between"
            spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
            <Grid
              item
              lg={8}
              md={8}
              sm={8}
              xs={8}
              pt={2}
              alignContent="center"
            >
              <Typography className={classes.cardTitle}>
               Change Password
              </Typography>
            </Grid>
             {/* <Grid item>
                        <Button
                                                     variant="contained"
                                                     className={classes.addButton}
                                                     onClick={() => handleOpenDialogOnline(customer)}
                                                   >
                                                    Add
                                                   </Button>
                     </Grid> */}
          </Grid>
        </Grid>


   
        <Grid item lg={6} md={6} sm={12} xs={12} >
          <Grid
            container
            justifyContent="space-between"
          //  spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
     
  <Grid container spacing={2}>
          {/* New Password */}
          <Grid item xs={12} >
            <TextField
              label="New Password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={handlePasswordChange}
              fullWidth
              size="small"
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                      size="small"
                    >
                      {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          {/* Confirm Password */}
          <Grid item xs={12}>
            <TextField
              label="Confirm Password"
              type={showConfirm ? "text" : "password"}
              value={confirmPassword}
              onChange={handleConfirmChange}
              fullWidth
              size="small"
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowConfirm(!showConfirm)}
                      edge="end"
                      size="small"
                    >
                      {showConfirm ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          {/* Submit Button */}
          <Grid item xs={12}>
            <Button
              className={classes.addButton}
              variant="contained"
              onClick={handleSubmit}
              sx={{ mt: 1 }}
            >
              Save
            </Button>
          </Grid>
        </Grid>


          </Grid>
        </Grid>
      </Grid>
    </Card>
  </Grid>
)}



{showQuotes && (  
               
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <Card className={classes.card}>
                   <Grid
                     container
                     justifyContent={"space-between"}
                     spacing={5}
                     sx={{ borderBottom: 2, padding: 2 }}
                     className={classes.titleGrid}
                   >
                     <Grid
                       item
                       lg={4}
                       md={4}
                       sm={4}
                       xs={4}
                       pt={2}
                       alignContent={"center"}
                     >
                       <Typography className={classes.cardTitle}>
                         Quotes
                       </Typography>
                     </Grid>
                     <Grid
                       item
                       lg={8}
                       md={8}
                       sm={8}
                       xs={8}
                       sx={{ display: "flex", justifyContent: "flex-end" }}
                     >
                       <Grid
                         container
                         spacing={1}
                         justifyContent="flex-end"
                         sx={{ display: "flex" }}
                       >
                         <Grid item>
                           <TextField
                             InputProps={{
                               startAdornment: (
                                 <InputAdornment position="start">
                                   <CiSearch
                                     className={classes.searchWidgetIcon}
                                   />
                                 </InputAdornment>
                               ),
                               classes: {
                                 root: classes.formControlList,
                               },
                             }}
                         fullWidth
                         value={searchQueryQuotes}
                         onChange={(e) =>
                           setSearchQueryQuotes(e.target.value)
                         }
                         placeholder="Name .."
                         sx={{ width: "100%" }}
                         size="small"
                       />
                     </Grid>

                     <Grid item>
                       <Button
                         variant="contained"
                         className={classes.addButton}
                         onClick={() =>
                           navigate(`/quote/create/${customerId}`)
                         }
                       >
                         Add Quote
                       </Button>
                     </Grid>
                   </Grid>
                 </Grid>
               </Grid>

               <Grid>
                 <TableContainer>
                   <Table className={classes.table}>
                     <TableHead className={classes.tableHeaderRow}>
                       <TableRow>
                       <TableCell className={classes.tablheader}>
             <CustomCheckbox name="checkbox"
               onChange={handleSelectAllRowsQuotes}
               checked={selectedRowsQuotes.length === quoteList.length}
             />
           </TableCell>
         
                         <TableCell className={classes.tablheader}>
                           <strong>Work Order No</strong>
                         </TableCell>
                         <TableCell className={classes.tablheader}>
                           <strong>Status</strong>
                         </TableCell>
                         <TableCell className={classes.tablheader}>
                           <strong>Amount</strong>
                         </TableCell>
                         <TableCell className={classes.tablheader}>
                           <strong>Create Date</strong>
                         </TableCell>
                        
                         <TableCell
                           className={classes.tablheader}
                           sx={{ textAlign: "right" }}
                         >
                           <strong>Actions</strong>
                         </TableCell>
                       </TableRow>
                     </TableHead>
                     <TableBody>
                     {quoteList.filter((transaction) => 
      String(transaction.quoteWorkOrderCustomerId) === String(customerId)  && 
      !transaction.invoiceId // Only include work orders without an invoicd
    ).
                       map((transaction) =>  {
                           const statusLabel = getStatusLabel(transaction.quoteWorkOrderStatus);
                           const statusColor = getStatusColor(transaction.quoteWorkOrderStatus);
                           const invoice = invoiceList?.find((invoice) =>
                            String(invoice.id) === String(transaction.invoiceId)
                          );

                          const invoiceNo = invoice ? invoice.InvoiceNo : "N/A";
                          const invoiceAmt = invoice ? invoice.quoteWorkOrderSaleGrandTotal : 0;
                          const invoiceStatus = invoice ? invoice.quoteWorkOrderStatus : null;
                          const statusForLabel = invoiceStatus === null ? 0 : invoiceStatus; 
                          const invoiceStatusLabel = getStatusLabel(statusForLabel);
                          const invoiceStatusColor = getStatusColor(statusForLabel);
                          const invoiceQuoteWorkOrderStatus = invoice ? invoice.quoteWorkOrderStatus : "N/A";
                          const amountPaid = invoice ? parseFloat(String(invoice.amount_paid) || "0") : 0;
                          const balance = invoice
                          ? Math.max(0, parseFloat(invoice.quoteWorkOrderSaleGrandTotal || "0") - amountPaid)
                          : parseFloat(transaction.quoteWorkOrderSaleGrandTotal || "0");
                          const formatAmount = (amount: number) => amount.toFixed(2);

                         return(
                         <TableRow
                           key={transaction.id}
                           className={classes.tableRowHover}
                         >
                            <TableCell component="th"
                             scope="row"
                             className={classes.tablCell}>
               
             
                        <CustomCheckbox name="checkbox" 
                   checked={selectedRowsQuotes.includes(transaction.id)}
                   onChange={() => handleSelectRowQuotes(transaction.id)}
                 />
                   </TableCell>
                        
                         <TableCell
                             component="th"
                             scope="row"
                             className={classes.tablCell}
                           >
                            <Link
    to={`/work-order/history/${transaction.id}`} // Replace with the correct path to your desired page
    style={{ textDecoration: 'none', color: 'inherit',cursor: 'pointer', }} // Optional: style to remove link styling
  >
                             {transaction.quoteWorkOrderNo}</Link>
                             {transaction.invoiceId && (
                               <span
                                 style={{
                                   backgroundColor: '#4caf50',
                                   color: '#fff',
                                   borderRadius: '12px',
                                   padding: '2px 8px',
                                   marginLeft: '8px',
                                   fontSize: '0.7rem',
                                   fontWeight: '500',
                                  //  cursor: 'pointer',
                                 }}
                                 onClick={() => handleOpenViewInvoice(String(transaction.invoiceId))}
                               >
                                {invoiceNo}
                               </span>
                             )}
                           </TableCell>
                           
                        
                           <TableCell scope="row" className={classes.tablCell}>
                           <Button
                                                                                    className={classes.statusButtonList}
                                                                                    style={{
                                                                                      color: statusColor,
                                                                                      backgroundColor: transaction.quoteWorkOrderStatus === WorkOrderStatus.Paid
                                                                                      ? "#e1f8d5"
                                                                                      : transaction.quoteWorkOrderStatus === WorkOrderStatus.Cancel
                                                                                      ? "#f8d7da"
                                                                                      : transaction.quoteWorkOrderStatus === WorkOrderStatus.Pending
                                                                                      ? "lightyellow"
                                                                                        : transaction.quoteWorkOrderStatus === WorkOrderStatus.Initiated
                                                                                      ? "#e2fafa"
                                                                                      : "#ffffff", // Fallback for other statuses
                                                                                      border: "solid 1px",
                                                                                      borderColor: statusColor,
                                                                                      borderRadius: "8px",
                                                                                      
                                                                                    }}
                                                                                  >
                                                                                    {statusLabel}
                                                                                  </Button>
                                                   </TableCell>
                                                   <TableCell
                             component="th"
                             scope="row"
                             className={classes.tablCell}
                           >
                             {"$"}
                             {parseFloat(
                               transaction?.quoteWorkOrderSaleGrandTotal ||
                                 "0"
                             ).toFixed(2)}
                           </TableCell>
                           <TableCell
                             scope="row"
                             className={classes.tablCell}
                           >
                             {transaction?.created_at
                               ? dayjs(transaction.created_at).format(
                                   "MMM D, YYYY [at] h:mm A"
                                 )
                               : ""}
                           </TableCell>
                          

                           <TableCell
                             scope="row"
                             className={classes.tablCell}
                           >
                             <Grid
                               container
                               spacing={1}
                               sx={{
                                 display: "flex",
                                 justifyContent: "flex-end",
                               }}
                             >
                               <Grid item>
                           
                             

                                 <Button
                                   variant="contained"
                                   className={classes.viewButtonList}
                                   onClick={() => handleOpenViewQuote(String(transaction.id))}
                                   // onClick={() =>
                                   //   navigate(
                                   //     `/invoice/history/${transaction.id}`
                                   //   )
                                   // }
                                 >
                                   <VisibilitySharpIcon
                                     className={classes.viewListIcon}
                                   />
                                 </Button>
                               </Grid>

                               <Grid item>
                              <Button
                                variant="contained"
                                className={classes.editButtonList}
                                onClick={() =>
                                  navigate(`/quote-history/${transaction.id}`)
                                }
                              >
                                <EditSharpIcon
                                  className={classes.editListIcon}
                                />
                              </Button>
                            </Grid>
                      
                             </Grid>
                           </TableCell>
                         </TableRow>
                         )
})}
                     </TableBody>
                   </Table>
                 </TableContainer>

                 {selectedRowsQuotes.length > 0 && (
                   <Grid>
                    
     <Button disabled={pdfLoading}  variant="contained"
     className={classes.addButton} onClick={handleQuoteEmailDialogOpen}>
       {pdfLoading ? <CircularProgress size={24} /> : "Send Email"}
     </Button>
     </Grid>
   )}








<Dialog open={showEmailDialog} onClose={handleQuoteEmailDialogClose} maxWidth="sm" fullWidth>
     <DialogTitle>Send Email
     <IconButton
 aria-label="close"
 onClick={handleQuoteEmailDialogClose}
 sx={{
   position: 'absolute',
   right: 8,
   top: 8,
   color: (theme) => theme.palette.grey[500],
 }}
>
 <CloseIcon />
</IconButton>
     </DialogTitle>
     <DialogContent>
          <Grid container spacing={1} p={"14px"}>
         <Grid item lg={12} md={12} sm={12} xs={12}>
                             <Grid container alignItems="center">
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                 <Typography variant="subtitle1">
                                    To
                                 </Typography>
                               </Grid>
                               <Grid item lg={12} md={12} sm={12} xs={12}>
       <TextField
         size="small"
         className={classes.textField}
         InputProps={{
           sx: {
             fontSize: 14,
           },
         }}
         InputLabelProps={{
           sx: {
             fontSize: 14,
           },
         }}
         value={invoiceEmailData.to}
         onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, to: e.target.value })}
       />
         </Grid>
                             </Grid>
                           </Grid>
                           <Grid item lg={12} md={12} sm={12} xs={12}>
                             <Grid container alignItems="center">
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                 <Typography variant="subtitle1">
                                    Select Template
                                 </Typography>
                               </Grid>
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                               <TextField
  size="small"
  rows={4}
  className={classes.textField}
  select
  value={invoiceEmailData.template}  // Controlled by state
  onChange={(event) => {
    const selectedTemplateId = event.target.value;
    setInvoiceEmailData({
      ...invoiceEmailData,
      template: selectedTemplateId, // Update selected template
      subject: invoiceEmailData.subject, // Reset subject and message when template changes
      message: invoiceEmailData.message,
    });
  }}

    >
    <MenuItem value="">
    Select option
    </MenuItem>
    {emailTemplateList.map((template) => (
    <MenuItem key={template.id} value={template.id}>
     {template.template_name} {/* Display the name of the template */}
    </MenuItem>
    ))}
    </TextField>
</Grid>
                             </Grid>
                           </Grid>

                           <Grid item lg={12} md={12} sm={12} xs={12}>
                             <Grid container alignItems="center">
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                 <Typography variant="subtitle1">
                                   Subject
                                 </Typography>
                               </Grid>
                               <Grid item lg={12} md={12} sm={12} xs={12}>
       <TextField
        size="small"
        className={classes.textField}
        InputProps={{
          sx: {
            fontSize: 14,
          },
        }}
        InputLabelProps={{
          sx: {
            fontSize: 14,
          },
        }}
         value={invoiceEmailData.subject}
         onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, subject: e.target.value })}
       />
       </Grid>
                             </Grid>
                           </Grid>

                           <Grid item lg={12} md={12} sm={12} xs={12}>
  <Grid container alignItems="center">
    {/* Message Label */}
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Message</Typography>
    </Grid>

    <Grid item lg={12} md={12} sm={12} xs={12}>

<ReactQuill
        value={invoiceEmailData.message} // Bind only the message value
        onChange={(value) =>
          setInvoiceEmailData({ ...invoiceEmailData, message: value })
        } // Update message value in the state
        style={{
          height: "210px",
        }}
      />


</Grid>
  </Grid>
</Grid>

{/* Attachments Section */}
<Grid item lg={12} md={12} sm={12} xs={12} sx={{ marginTop: 5 }}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1" gutterBottom>
        Attachments: {selectedRowsQuotes.length} Work order selected
      </Typography>
    </Grid>
  </Grid>
</Grid>


       
       </Grid>
     </DialogContent>
     <DialogActions>



     <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
           <Card className={classes.card}>
             <Grid container spacing={3} p={"24px"}>
               <Grid
                 item
                 lg={12}
                 md={12}
                 sm={12}
                 xs={12}
                 sx={{ display: "flex", justifyContent: "flex-end" }}
               >
               
       {/* <Button   disabled={loading}   startIcon={<SaveAltIcon />} 
     className={classes.addButton} onClick={handleSendEmail} variant="contained">
       {loading ? <CircularProgress size={24} /> : "Send"}
       </Button> */}
       </Grid>
       </Grid>
       </Card>
       </Grid>
     </DialogActions>
   </Dialog>



                 {/* {openViewQuote && (
<Dialog open={openViewQuote} onClose={handleCloseViewQuote} maxWidth="md" fullWidth
>
<DialogTitle><Typography variant="h5" component="div">
Work Order Details
</Typography></DialogTitle>
<DialogContent >
<ViewWorkOrder  quoteId={quoteId} type="view" /> 
</DialogContent>
<DialogActions>
 <Button onClick={handleCloseViewQuote}>Close</Button>
</DialogActions>
</Dialog>
)} */}

            {/* {openViewInvoice && (
                   <ViewInvoice
                     openModel={openViewInvoice}
                     handleCloseDialog={handleCloseViewInvoice}
                     invoiceId={invoiceId}
                   />
                 )} */}


                 {/* {selectCustomer && (
                   <NewPopUpCustomer
                     openModel={openDialog}
                     handleCloseDialog={handleCloseDialog}
                     data={selectCustomer}
                   />
                 )} */}
                 {/* {openAddTransaction && (
                   <NewCustomerTransactionPopUp
                     openModel={openAddTransaction}
                     handleCloseDialog={handleCloseAddTransaction}
                     data={transactionData}
                     customerId={customerId}
                   />
                 )} */}
                 {coursingToDelete && (
                   <DeletePopup
                     open={openDeleteCategory}
                     handleCloseDelete={handleCloseDeletePopup}
                     onConfirm={async () => {
                       await handleDelete(coursingToDelete.id.toString());
                     }}
                     title="Delete Customer"
                     content={`Are you sure you want to delete "${coursingToDelete.transactionName}"?`}
                   />
                 )}
               </Grid>
             </Card>
           </Grid>
        

               )}                  


{showInvoice && (  
               
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Typography className={classes.cardTitle}>
                              Invoices
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                            <Grid
                              container
                              spacing={1}
                              justifyContent="flex-end"
                              sx={{ display: "flex" }}
                            >
                              <Grid item>
                                <TextField
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <CiSearch
                                          className={classes.searchWidgetIcon}
                                        />
                                      </InputAdornment>
                                    ),
                                    classes: {
                                      root: classes.formControlList,
                                    },
                                  }}
                              fullWidth
                              value={searchQueryInvoice}
                              onChange={(e) =>
                                setSearchQueryInvoice(e.target.value)
                              }
                              placeholder="Name .."
                              sx={{ width: "100%" }}
                              size="small"
                            />
                          </Grid>

                          <Grid item>
                            <Button
                              variant="contained"
                              className={classes.addButton}
                              onClick={() =>
                                navigate(`/invoice/create/${customerId}`)
                              }
                            >
                              Add Invoice
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid>
                      <TableContainer>
                        <Table className={classes.table}>
                          <TableHead className={classes.tableHeaderRow}>
                            <TableRow>
                            <TableCell className={classes.tablheader}>
                  <CustomCheckbox name="checkbox"
                    onChange={handleSelectAllRows}
                    checked={selectedRows.length === invoiceList.length}
                  />
                </TableCell>
              
                              <TableCell className={classes.tablheader}>
                                <strong>Invoice No</strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Status</strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Amount</strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Create Date</strong>
                              </TableCell>

                              <TableCell
                                className={classes.tablheader}
                                sx={{ textAlign: "right" }}
                              >
                                <strong>Actions</strong>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {invoiceList.map((transaction) =>  {
                                const statusLabel = getStatusLabel(transaction.quoteWorkOrderStatus);
                                const statusColor = getStatusColor(transaction.quoteWorkOrderStatus);
                                return(
                              <TableRow
                                key={transaction.id}
                                className={classes.tableRowHover}
                              >
                                 <TableCell component="th"
                                  scope="row"
                                  className={classes.tablCell}>
                    
                  
                             <CustomCheckbox name="checkbox" 
                        checked={selectedRows.includes(transaction.id)}
                        onChange={() => handleSelectRow(transaction.id)}
                      />
                        </TableCell>
                        <TableCell
                                  component="th"
                                  scope="row"
                                  className={classes.tablCell}
                                  sx={{ whiteSpace: "nowrap", cursor: "pointer" }}
                                  onClick={() => navigate(`/work-order/history/${transaction.work_order_id}`)}
                                >
                                  {transaction.InvoiceNo}
                                </TableCell>
                                <TableCell scope="row" className={classes.tablCell}>
                                <Button
                                                                                    className={classes.statusButtonList}
                                                                                    style={{
                                                                                      color: statusColor,
                                                                                      backgroundColor: transaction.quoteWorkOrderStatus === WorkOrderStatus.Paid
                                                                                      ? "#e1f8d5"
                                                                                      : transaction.quoteWorkOrderStatus === WorkOrderStatus.Cancel
                                                                                      ? "#f8d7da"
                                                                                      : transaction.quoteWorkOrderStatus === WorkOrderStatus.Pending
                                                                                      ? "lightyellow"
                                                                                        : transaction.quoteWorkOrderStatus === WorkOrderStatus.Initiated
                                                                                      ? "#e2fafa"
                                                                                      : "#ffffff", // Fallback for other statuses
                                                                                      border: "solid 1px",
                                                                                      borderColor: statusColor,
                                                                                      borderRadius: "8px",
                                                                                      
                                                                                    }}
                                                                                  >
                                                                                    {statusLabel}
                                                                                  </Button>
                                                       </TableCell>
                                                       <TableCell
                                  component="th"
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  {"$"}
                                  {parseFloat(
                                    transaction?.quoteWorkOrderSaleGrandTotal ||
                                      "0"
                                  ).toFixed(2)}
                                </TableCell>

                                <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  {transaction?.created_at
                                    ? dayjs(transaction.created_at).format(
                                        "MMM D, YYYY [at] h:mm A"
                                      )
                                    : ""}
                                </TableCell>
                              

                                <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  <Grid
                                    container
                                    spacing={1}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    
                                
                                    <Grid item>
                                
                                    {/* <div ref={invoiceRef} >
    <ViewInvoice invoiceId={String(transaction.id)} />
</div> */}

                                      <Button
                                        variant="contained"
                                        className={classes.viewButtonList}
                                        onClick={() => handleOpenViewInvoice(String(transaction.id))}
                                        // onClick={() =>
                                        //   navigate(
                                        //     `/invoice/history/${transaction.id}`
                                        //   )
                                        // }
                                      >
                                        <VisibilitySharpIcon
                                          className={classes.viewListIcon}
                                        />
                                      </Button>
                                    </Grid>

                                    <Grid item>
                          <Button
  variant="contained"
  className={classes.editButtonList}
  onClick={() =>
    navigate(
      transaction.project?.id
        ? `/invoice/project/edit/${transaction.id}` // Redirect to project-specific edit page
        : `/invoice/edit/${transaction.id}` // Redirect to regular edit page
    )
  }
>
  <EditSharpIcon className={classes.editListIcon} />
</Button>

</Grid>

                           
                                  </Grid>
                                </TableCell>
                              </TableRow>
                              )
})}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      {selectedRows.length > 0 && (
                        <Grid>
          <Button disabled={pdfLoading}  variant="contained"
          className={classes.addButton} onClick={handleEmailDialogOpen}>
        {pdfLoading ? <CircularProgress size={24} /> : "Send Email"}
          </Button>
          </Grid>
        )}
  {/* <div id="invoice-content" 
  style={{ display: 'none' }}
   >
  <ViewInvoice   invoiceId={invoiceId} type="email" />
  </div> */}


 


<Dialog open={showEmailDialog} onClose={handleEmailDialogClose} maxWidth="sm" fullWidth>
          <DialogTitle>Send Email
          <IconButton
      aria-label="close"
      onClick={handleEmailDialogClose}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CloseIcon />
    </IconButton>
          </DialogTitle>
          <DialogContent>
               <Grid container spacing={1} p={"14px"}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container alignItems="center">
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Typography variant="subtitle1">
                                         To
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              size="small"
              className={classes.textField}
              InputProps={{
                sx: {
                  fontSize: 14,
                },
              }}
              InputLabelProps={{
                sx: {
                  fontSize: 14,
                },
              }}
              value={invoiceEmailData.to}
              onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, to: e.target.value })}
            />
              </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container alignItems="center">
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Typography variant="subtitle1">
                                         Select Template
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <TextField
  size="small"
  rows={4}
  className={classes.textField}
  select
  value={invoiceEmailData.template}  // Controlled by state
  onChange={(event) => {
    const selectedTemplateId = event.target.value;
    setInvoiceEmailData({
      ...invoiceEmailData,
      template: selectedTemplateId, // Update selected template
      subject: invoiceEmailData.subject, // Reset subject and message when template changes
      message: invoiceEmailData.message,
    });
  }}

    >
    <MenuItem value="">
    Select option
    </MenuItem>
    {emailTemplateList.map((template) => (
    <MenuItem key={template.id} value={template.id}>
     {template.template_name} {/* Display the name of the template */}
    </MenuItem>
    ))}
    </TextField>
</Grid>
                                  </Grid>
                                </Grid>

                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container alignItems="center">
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Typography variant="subtitle1">
                                        Subject
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
             size="small"
             className={classes.textField}
             InputProps={{
               sx: {
                 fontSize: 14,
               },
             }}
             InputLabelProps={{
               sx: {
                 fontSize: 14,
               },
             }}
              value={invoiceEmailData.subject}
              onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, subject: e.target.value })}
            />
            </Grid>
                                  </Grid>
                                </Grid>

                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container alignItems="center">
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Typography variant="subtitle1">
                                        Message
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>

            {/* <TextField
            size="small"
            className={classes.textField}
            InputProps={{
              sx: {
                fontSize: 14,
              },
            }}
            InputLabelProps={{
              sx: {
                fontSize: 14,
              },
            }}
              multiline
              rows={7}
              value={invoiceEmailData.message}
              onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, message: e.target.value })}
            /> */}
  <ReactQuill
        value={invoiceEmailData.message} // Bind only the message value
        onChange={(value) =>
          setInvoiceEmailData({ ...invoiceEmailData, message: value })
        } // Update message value in the state
        style={{
          height: "210px",
        }}
      />
            
            </Grid>
                                  </Grid>
                                </Grid>

                                <Grid item lg={12} md={12} sm={12} xs={12} sx={{ marginTop: 5 }}>
                                  <Grid container alignItems="center">
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>

            <Typography variant="subtitle1" gutterBottom>
              Attachments: {selectedRows.length} invoices selected
            </Typography>
            </Grid>
            </Grid>
            </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>



          <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                <Card className={classes.card}>
                  <Grid container spacing={3} p={"24px"}>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                    
            {/* <Button   disabled={loading}   startIcon={<SaveAltIcon />} 
          className={classes.addButton} onClick={handleSendEmail} variant="contained">
            {loading ? <CircularProgress size={24} /> : "Send"}
            </Button> */}
            </Grid>
            </Grid>
            </Card>
            </Grid>
          </DialogActions>
        </Dialog>



                      {/* {openViewInvoice && (
  <Dialog open={openViewInvoice} onClose={handleCloseViewInvoice} maxWidth="md" fullWidth
  >
    <DialogTitle><Typography variant="h5" component="div">
    Invoice Details
  </Typography></DialogTitle>
    <DialogContent >
    <ViewInvoice  invoiceId={invoiceId} type="view"/> 
    </DialogContent>
    <DialogActions>
      <Button onClick={handleCloseViewInvoice}>Close</Button>
    </DialogActions>
  </Dialog>
)} */}

                 {/* {openViewInvoice && (
                        <ViewInvoice
                          openModel={openViewInvoice}
                          handleCloseDialog={handleCloseViewInvoice}
                          invoiceId={invoiceId}
                        />
                      )} */}


                      {/* {selectCustomer && (
                        <NewPopUpCustomer
                          openModel={openDialog}
                          handleCloseDialog={handleCloseDialog}
                          data={selectCustomer}
                        />
                      )} */}
                      {/* {openAddTransaction && (
                        <NewCustomerTransactionPopUp
                          openModel={openAddTransaction}
                          handleCloseDialog={handleCloseAddTransaction}
                          data={transactionData}
                          customerId={customerId}
                        />
                      )} */}
                      {coursingToDelete && (
                        <DeletePopup
                          open={openDeleteCategory}
                          handleCloseDelete={handleCloseDeletePopup}
                          onConfirm={async () => {
                            await handleDelete(coursingToDelete.id.toString());
                          }}
                          title="Delete Customer"
                          content={`Are you sure you want to delete "${coursingToDelete.transactionName}"?`}
                        />
                      )}
                    </Grid>
                  </Card>
                </Grid>
             

                    )}

          
       



{showEmailForm && (


                  <><Grid item lg={12} md={12} sm={12} xs={12}>
                    <form onSubmit={emailFormik.handleSubmit}>
                      <Grid container>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Card className={classes.card}>
                            <Grid
                              container
                              justifyContent={"space-between"}
                              spacing={5}
                              sx={{ borderBottom: 2, padding: 2 }}
                              className={classes.titleGrid}
                            >
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                pt={2}
                                alignContent={"center"}
                              >
                                <Typography className={classes.cardTitle}>
                                  Compose Email
                                </Typography>
                              </Grid>
                            </Grid>

                            <Grid container spacing={3} p={"24px"}>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Grid container alignItems="center">
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant="subtitle1">
                                      To
                                    </Typography>
                                  </Grid>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <TextField
                                      placeholder="Enter Email"
                                      size="small"
                                      {...emailFormik.getFieldProps("to")}
                                      className={classes.textField}
                                      InputProps={{
                                        sx: {
                                          fontSize: 14,
                                        },
                                      }}
                                      InputLabelProps={{
                                        sx: {
                                          fontSize: 14,
                                        },
                                      }}
                                      error={emailFormik.touched.to &&
                                        Boolean(emailFormik.errors.to)}
                                      helperText={emailFormik.touched.to &&
                                        emailFormik.errors.to}
                                       />
                                  </Grid>
                                </Grid>
                              </Grid>


                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Grid container alignItems="center">
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant="subtitle1">
                                      Subject
                                    </Typography>
                                  </Grid>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <TextField
                                      placeholder="Enter Subject"
                                      size="small"
                                      {...emailFormik.getFieldProps("subject")}
                                      className={classes.textField}
                                      InputProps={{
                                        sx: {
                                          fontSize: 14,
                                        },
                                      }}
                                      InputLabelProps={{
                                        sx: {
                                          fontSize: 14,
                                        },
                                      }} />
                                  </Grid>
                                </Grid>
                              </Grid>

                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Grid container alignItems="center">
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant="subtitle1">
                                      Message
                                    </Typography>
                                  </Grid>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <div
                                      style={{
                                        height: "210px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px", // Optional: Add some rounding to the corners
                                        overflow: "hidden", // Prevent content overflow
                                      }}
                                    >
                                      <ReactQuill
                                        value={emailFormik.values.message}
                                        onChange={(value) => emailFormik.setFieldValue("message", value)}
                                        style={{
                                          height: "210px",
                                        }} />

                                    </div>


                                  </Grid>
                                </Grid>
                              </Grid>


                              <Grid item lg={10} md={12} sm={12} xs={12}>
                                <Grid container alignItems="center">
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant="subtitle1">Select Template</Typography>
                                  </Grid>
                                  <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <TextField
                                      select
                                      size="small"
                                      className={classes.textField}
                                      SelectProps={{
                                        native: false,
                                      }}
                                      defaultValue=""
                                      value={emailFormik.values.template}
                                      InputLabelProps={{ shrink: true }}
                                      onChange={(event) => {
                                        const selectedTemplateId = event.target.value;

                                        const selectedTemplate = emailTemplateList.find(template => template.id === Number(selectedTemplateId));

                                        if (selectedTemplate) {
                                          // Set the form fields for subject and message based on the selected template
                                          emailFormik.setFieldValue("subject", selectedTemplate.subject);
                                          emailFormik.setFieldValue("message", convertPlainTextToHTML(selectedTemplate.message));
                                        } else {
                                          // Reset the subject and message if "Select an option" is chosen
                                          emailFormik.setFieldValue("subject", "");
                                          emailFormik.setFieldValue("message", "");
                                        }
                                        // Set the selected template value
                                        emailFormik.setFieldValue("template", selectedTemplateId);
                                      } }
                                    >
                                      <MenuItem value="Select option">
                                        Select option
                                      </MenuItem>

                                      {emailTemplateList.map((template) => (
                                        <MenuItem key={template.id} value={template.id}>
                                          {template.template_name} {/* Display the name of the template */}
                                        </MenuItem>
                                      ))}

                                    </TextField>
                                  </Grid>
                                </Grid>
                              </Grid>



                            </Grid>
                          </Card>
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                          <Card className={classes.card}>
                            <Grid container spacing={3} p={"24px"}>
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                sx={{ display: "flex", justifyContent: "flex-end" }}
                              >

                                <Button
                                  variant="contained"
                                  startIcon={<SaveAltIcon />}
                                  className={classes.addButton}
                                  onClick={() => emailFormik.handleSubmit()}
                                  disabled={!emailFormValid || isEmailSending}
                                >
                                  Send
                                </Button>
                              </Grid>
                            </Grid>
                          </Card>
                        </Grid>
                      </Grid>
                    </form>
                  </Grid>
                  
                  
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Typography className={classes.cardTitle}>
                              Email History
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                            <Grid
                              container
                              spacing={1}
                              justifyContent="flex-end"
                              sx={{ display: "flex" }}
                            >
                              <Grid item>
                                {/* <TextField
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <CiSearch
                                          className={classes.searchWidgetIcon} />
                                      </InputAdornment>
                                    ),
                                    classes: {
                                      root: classes.formControlList,
                                    },
                                  }}
                                  fullWidth
                                  value={searchQueryProject}
                                  onChange={(e) => setSearchQueryProject(e.target.value)}
                                  placeholder="Name .."
                                  sx={{ width: "100%" }}
                                  size="small" /> */}
                              </Grid>

                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid>
                          <TableContainer>
                            <Table className={classes.table}>
                              <TableHead className={classes.tableHeaderRow}>
                                <TableRow>
                                <TableCell className={classes.tablheader}>
                                    <strong> Date</strong>
                                  </TableCell>

                                  
                                  <TableCell className={classes.tablheader}>
                                    <strong>Recepient</strong>
                                  </TableCell>
                                 
                                  <TableCell className={classes.tablheader}>
                                    <strong>Subject</strong>
                                  </TableCell>

                               
                                </TableRow>
                              </TableHead>
                              <TableBody>
                              {Array.isArray(emailLogs) && emailLogs.length > 0 ? (
            emailLogs
            // .filter(log => log.project_id === null)
            .map((log) => (
              <TableRow key={log.id} className={classes.tableRowHover}>
                <TableCell className={classes.tablCell}>
                  {log?.created_at
                    ? dayjs(log.created_at).format("MMM D, YYYY [at] h:mm A")
                    : ""}
                </TableCell>

                
                <TableCell className={classes.tablCell}>
                  {log.to || ""}
                </TableCell>

                <TableCell className={classes.tablCell}>
                  {log.subject || "No Subject"}
                </TableCell>

               

           

              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={2} className={classes.tablCell}>
                No email logs found.
              </TableCell>
            </TableRow>
          )}
                              </TableBody>
                            </Table>
                          </TableContainer>

                        
                        </Grid>
                      </Card>
                    </Grid>



</>



        )}

{/* {showTextForm && (
         <Grid item lg={12} md={12} sm={12} xs={12}>
         <form onSubmit={textFormik.handleSubmit}>
           <Grid container>
             <Grid item lg={12} md={12} sm={12} xs={12}>
               <Card className={classes.card}>
                 <Grid
                   container
                   justifyContent={"space-between"}
                   spacing={5}
                   sx={{ borderBottom: 2, padding: 2 }}
                   className={classes.titleGrid}
                 >
                   <Grid
                     item
                     lg={12}
                     md={12}
                     sm={12}
                     xs={12}
                     pt={2}
                     alignContent={"center"}
                   >
                     <Typography className={classes.cardTitle}>
                      New Message
                     </Typography>
                   </Grid>
                 </Grid>

                 <Grid container spacing={3} p={"24px"}>

                 
                   <Grid item lg={12} md={12} sm={12} xs={12}>
                     <Grid container alignItems="center">
                       <Grid item lg={12} md={12} sm={12} xs={12}>
                         <Typography variant="subtitle1">
                           Text Message
                         </Typography>
                       </Grid>
                       <Grid item lg={12} md={12} sm={12} xs={12}>
                       <div
       style={{
       height: "210px",
      border:  "1px solid #ccc", 
      borderRadius: "4px", // Optional: Add some rounding to the corners
       overflow: "hidden", // Prevent content overflow
     }}
   >
               <ReactQuill
                 value={textFormik.values.message}
                 onChange={(value) => textFormik.setFieldValue("message", value)}
                 style={{
                   height: "210px",
                 }}
               />
               
   </div>

                       </Grid>
                     </Grid>
                   </Grid>

               
 

                 </Grid>
               </Card>
             </Grid>

             <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
               <Card className={classes.card}>
                 <Grid container spacing={3} p={"24px"}>
                   <Grid
                     item
                     lg={12}
                     md={12}
                     sm={12}
                     xs={12}
                     sx={{ display: "flex", justifyContent: "flex-end" }}
                   >
                   
                     <Button
                       variant="contained"
                       startIcon={<SaveAltIcon />}
                       className={classes.addButton}
                       onClick={() => textFormik.handleSubmit()}
                       disabled={!textFormValid || isTextSending}
                     >
                        Send
                     </Button>
                   </Grid>
                 </Grid>
               </Card>
             </Grid>
           </Grid>
         </form>
       </Grid>
        )}  */}



     {/* {showNoteForm && (
         <Grid item lg={12} md={12} sm={12} xs={12}>
         <form onSubmit={noteFormik.handleSubmit}>
           <Grid container>
             <Grid item lg={12} md={12} sm={12} xs={12}>
               <Card className={classes.card}>
                 <Grid
                   container
                   justifyContent={"space-between"}
                   spacing={5}
                   sx={{ borderBottom: 2, padding: 2 }}
                   className={classes.titleGrid}
                 >
                   <Grid
                     item
                     lg={12}
                     md={12}
                     sm={12}
                     xs={12}
                     pt={2}
                     alignContent={"center"}
                   >
                     <Typography className={classes.cardTitle}>
                      New Message
                     </Typography>
                   </Grid>
                 </Grid>

                 <Grid container spacing={3} p={"24px"}>

                   <Grid item lg={12} md={12} sm={12} xs={12}>
                     <Grid container alignItems="center">
                       <Grid item lg={12} md={12} sm={12} xs={12}>
                         <Typography variant="subtitle1">
                           Subject
                         </Typography>
                       </Grid>
                       <Grid item lg={12} md={12} sm={12} xs={12}>
                         <TextField
                           placeholder="Enter Subject"
                           size="small"
                           {...noteFormik.getFieldProps("subject")}
                           className={classes.textField}
                           InputProps={{
                             sx: {
                               fontSize: 14,
                             },
                           }}
                           InputLabelProps={{
                             sx: {
                               fontSize: 14,
                             },
                           }}
                          
                         />
                       </Grid>
                     </Grid>
                   </Grid>

                   <Grid item lg={12} md={12} sm={12} xs={12}>
                     <Grid container alignItems="center">
                       <Grid item lg={12} md={12} sm={12} xs={12}>
                         <Typography variant="subtitle1">
                           Note Message
                         </Typography>
                       </Grid>
                       <Grid item lg={12} md={12} sm={12} xs={12}>
                       <div
       style={{
       height: "210px",
      border:  "1px solid #ccc", 
      borderRadius: "4px", // Optional: Add some rounding to the corners
       overflow: "hidden", // Prevent content overflow
     }}
   >
               <ReactQuill
                 value={noteFormik.values.message}
                 onChange={(value) => noteFormik.setFieldValue("message", value)}
                 style={{
                   height: "210px",
                 }}
               />
               
   </div>

  
                       </Grid>
                     </Grid>
                   </Grid>

                   <Grid item lg={10} md={12} sm={12} xs={12}>
          <Grid container alignItems="center">
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <Typography variant="subtitle1">Send as Email</Typography>
              <Switch
                checked={isSendAsEmail}
                onChange={handleToggleChange}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            </Grid>
          </Grid>
        </Grid>
          {isSendAsEmail && (
                   <Grid item lg={10} md={12} sm={12} xs={12}>
                     <Grid container alignItems="center">
                       <Grid item lg={12} md={12} sm={12} xs={12}>
                         <Typography variant="subtitle1">Select Template</Typography>
                       </Grid>
                       <Grid item lg={6} md={6} sm={12} xs={12}>
                         <TextField
                           select
                           size="small"
                           className={classes.textField}
                           SelectProps={{
                             native: false,
                           }}
                           defaultValue=""
                           InputLabelProps={{ shrink: true }}
                           onChange={(event) => {
                             const selectedTemplateId = event.target.value;
                           
                             const selectedTemplate = noteTemplateList.find(template => template.id === Number(selectedTemplateId));
                         
                             if (selectedTemplate) {
                               // Set the form fields for subject and message based on the selected template
                               noteFormik.setFieldValue("subject", selectedTemplate.subject);
                               noteFormik.setFieldValue("message", convertPlainTextToHTML(selectedTemplate.note_message));
                           }
                          
                            //  noteFormik.setFieldValue("template", selectedTemplateId);
                           }}
                         >
                           <MenuItem value="Select option" >
                             Select option
                           </MenuItem>
                         
       {noteTemplateList.map((template) => (
         <MenuItem key={template.id} value={template.id}>
           {template.note_title} 
         </MenuItem>
       ))}
                         
                         </TextField>
                       </Grid>
                     </Grid>
                   </Grid>

)}

                 </Grid>
               </Card>
             </Grid>

             <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
               <Card className={classes.card}>
                 <Grid container spacing={3} p={"24px"}>
                   <Grid
                     item
                     lg={12}
                     md={12}
                     sm={12}
                     xs={12}
                     sx={{ display: "flex", justifyContent: "flex-end" }}
                   >
                   
                     <Button
                       variant="contained"
                       startIcon={<SaveAltIcon />}
                       className={classes.addButton}
                       onClick={() => noteFormik.handleSubmit()}
                       disabled={!noteFormValid || isNoteSaving ||isNoteEmailSaving}
                     >
                     { isSendAsEmail ?'Send' : 'Save'}
                     </Button>
                   </Grid>
                 </Grid>
               </Card>
             </Grid>
           </Grid>
         </form>
       </Grid>
        )} */}



          </Grid>
        </Grid>



        {/* <Grid item lg={4} md={4} sm={12} xs={12}>
          <Grid container spacing={2}> */}


 {/* <Grid container spacing={1} sx={{ marginTop: 2, marginLeft: 1 }} justifyContent="center">

  <Grid item xs={12} sm={6} md={4}>
    <Card elevation={4} sx={{ borderRadius: 2 }}>
      <CardContent>
        <Grid container direction="column" alignItems="center">
          <Typography variant="h6" color="text.secondary" gutterBottom>
            No of Sales
          </Typography>
          <Typography
            variant="h5"
            sx={{ fontWeight: 700, color: '#2e7d32' }}
          >
            {totalSales}
          </Typography>
        </Grid>
      </CardContent>
    </Card>
  </Grid>


  <Grid item xs={12} sm={6} md={4}>
    <Card elevation={4} sx={{ borderRadius: 2}}>
      <CardContent>
        <Grid container direction="column" alignItems="center">
          <Typography variant="h6" color="text.secondary" gutterBottom>
            Sales Amount
          </Typography>
          <Typography
            variant="h5"
            sx={{ fontWeight: 700, color: '#0288d1' }}
          >
            ${totalAmount.toFixed(2)}
          </Typography>
        </Grid>
      </CardContent>
    </Card>
  </Grid>


  <Grid item xs={12} sm={6} md={4}>
    <Card elevation={4} sx={{ borderRadius: 2 }}>
      <CardContent>
        <Grid container direction="column" alignItems="center">
          <Typography variant="h6" color="text.secondary" gutterBottom>
            Last Sale
          </Typography>
          <Typography
            variant="h5"
            sx={{ fontWeight: 700, color: '#f57c00' }}
          >
            {moment(lastSaleDate).format('DD-MMM-YY')}
          </Typography>
        </Grid>
      </CardContent>
    </Card>
  </Grid>
</Grid> */}



            {/* <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.stepperCard}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Activity History
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                        className={classes.titleGrid}
                      >
                        <Box
                          sx={{
                            height: "600px",
                            overflow: "auto",
                            padding: "2px",
                            "&::-webkit-scrollbar": {
                              width: "4px",
                            },
                            "&::-webkit-scrollbar-track": {
                              background: "#eeeeee",
                            },
                            "&::-webkit-scrollbar-thumb": {
                              background: "#eeeeee",
                              borderRadius: "10px",
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                              background: "#eeeeee",
                            },
                          }}
                        >
                           <div>
    {timeLineSteps.length === 0 ? (
      <p style={{ textAlign: "center", padding: "20px" }}>No activity history found</p>
    ) : (
                          <Stepper
                            orientation="vertical"
                            activeStep={timeLineSteps.length}
                          >
                            {timeLineSteps.map((step, index) => (
                              <Step key={step.key} completed>
                                <StepLabel>
                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                  >
                                    <Typography className={classes.h5}>
                                      {step.label}
                                      <Typography
                                        variant="subtitle1"
                                        className={classes.showMoreLink}
                                        onClick={() => toggleStepDetails(index)}
                                      >
                                        {expandedSteps.includes(index)
                                          ? "Show less"
                                          : "Show more"}
                                      </Typography>
                                      <Typography
                                        variant="caption"
                                        color="textSecondary"
                                      >
                                // {step.time} 
                                      </Typography>
                                    </Typography>
                                    <Typography
                                      variant="caption"
                                      color="textSecondary"
                                      style={{whiteSpace:'nowrap'}}
                                    >
                                       {moment(`${step.date} ${step.time}`).format("MMM DD, YYYY, hh:mm a")}
                                    </Typography>
                                  </Box>
                                </StepLabel>

                                {expandedSteps.includes(index) && (
                                  <Box sx={{ ml: 4, mt: 1 }}>
                                    <Typography>{step.description}</Typography>
                                  </Box>
                                )}
                              </Step>
                            ))}

                           
                          </Stepper>
                          )}
  </div>
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Grid> */}
          {/* </Grid>
        </Grid> */}
        <Grid item lg={3} md={3} sm={12} xs={12}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
              <Card className={classes.stepperCard}></Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* <div
  id="quote-content" 
   style={{
    display: 'none',
  }}
  >

 <ViewWorkOrder quoteId={quoteId} type="email" />


  
  </div> */}

                      {selectCustomer && (
                        <NewCompanyOpeningHoursPopUp
                          openModel={openDialog}
                          handleCloseDialog={handleCloseDialog}
                          data={selectCustomer}
                        />
                      )} 

                       {selectOnline && (
                        <NewCompanyOnlineOpeningHoursPopUp
                          openModel={openDialogOnline}
                          handleCloseDialog={handleCloseDialogOnline}
                          data={selectOnline}
                        />
                      )} 


    </div>
  );
};

export default Index;
